<template>

    <div class="ree" :class="{'noflightwrap': searchObj &&  searchObj.trip==2? bindedFlightLs.ob == null
                            &&  bindedFlightLs.ib == null :false}">

      
      
                    <div class="flight-sticky-wrap">
                    <div class="sticky-wrapper" v-bind:class="{height_ex: isModifySearch}" >
                        <div class="sticky-nav">
                            <div v-if="searchObj && searchObj.route&&searchObj.route.length>0" class="place-wrapper">
                                <div class="place">
                                    <div @click="searchObj.trip==2?scrollToElement('scrollToDeparture'):null" v-if="searchObj.route[0].from" class="form">{{searchObj.route[0].from.depcode.city}} {{'('+searchObj.route[0].from.depcode.airportcode+')'}}</div>
                                    <div class="navigation-icon">

                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="510px" height="510px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve">
<g>
	<g id="flights">
		<path d="M510,255c0-20.4-17.85-38.25-38.25-38.25H331.5L204,12.75h-51l63.75,204H76.5l-38.25-51H0L25.5,255L0,344.25h38.25    l38.25-51h140.25l-63.75,204h51l127.5-204h140.25C492.15,293.25,510,275.4,510,255z"/>
	</g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
                                        <g>
</g>
</svg>
                                </div>
                                <div @click="searchObj.trip==2?scrollToElement('scrollToReturn'):null" v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0].to" class="to">
                                    {{searchObj.route[0].to.depcode.city}}
                                    {{'('+searchObj.route[0].to.depcode.airportcode+')'}}
                                </div>
                            </div>
                            <div v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0]&&!isModifySearch" class="date-info">
                                <div class="date">{{searchObj.route[0].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}</div>
                                <div class="passenger " v-if="searchObj.route[1]">
                                    {{searchObj.route[1].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                                </div>
                                <div v-if="searchObj.pax.adultCount>0" class="passenger">
                                  {{$tc("flightResults.adult",searchObj.pax.adultCount, { count: Number(searchObj.pax.adultCount) })}}
                                </div>
                                <div v-if="searchObj.pax.childCount>0" class="passenger">
                                  {{$tc("flightResults.child",searchObj.pax.childCount, { count: Number(searchObj.pax.childCount) })}}
                                </div>
                                <div v-if="searchObj.pax.infantCount>0" class="passenger">
                                  {{$tc("flightResults.infant",searchObj.pax.infantCount, { count: Number(searchObj.pax.infantCount) })}}
                                </div>
                                <div class="trip-type">{{searchObj.trip==1?$t("flightResults.oneWay")+' '+$t("flightResults.trip"):$t("flightResults.roundTrip")}}</div>

                                <div class="trip-type" v-if="searchObj.citizen&&searchObj.citizen.name">{{searchObj.citizen.name}}</div>

                                <div class="trip-type" v-if="searchObj.currency&&searchObj.currency.currency_code&&searchObj.currency.currency_code.code">{{searchObj.currency.currency_code.code}}</div>
                            </div>
                        </div>
                        <div class="sort-wrapper">
                            <div>
                                <button @click="isToggleCSearch" class="search-btn">
                                    {{$t('flightResults.modifySearch')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="search-pop-r" v-if="searchObj">
                        <transition name="bounce">
                            <cSearch v-if="isModifySearch" :searchObject="searchObj" v-on:send="onSearch"/>
                        </transition>
                    </div>
                </div>
                    </div>

    <cResultContentLoader :searchObj="searchObj" v-if="isLoading==true"></cResultContentLoader>
     <div v-show="isLoading==false">
     
            <div  class="">
  


            
            <div v-if="searchObj &&  searchObj.trip==2? bindedFlightLs.ob == null
                            &&  bindedFlightLs.ib == null :false">
                          <cEmptyFlightRes :isNoFlights="true">

                          </cEmptyFlightRes>
                        
                          </div>
           <!-- <div class="no-flight-wrapper"
          v-if="searchObj &&  searchObj.trip==2? bindedFlightLs.ob == null
          &&  bindedFlightLs.ib == null  :false"
          show
          color="danger"
        ><img src="@imgPath/img/gif/nothing-found.gif" alt="">
            <div>{{ $t("flightResults.flightNotAvail") }}</div></div>-->
            
        
         

    <div v-if="!bindedFlightLs && !showAlert">
        <ContentLoader >

            <rect x="6" y="8" rx="0" ry="0" width="451" height="74" />
            <rect x="8" y="97" rx="0" ry="0" width="451" height="74" />
            <rect x="7" y="184" rx="0" ry="0" width="451" height="74" />

           
        </ContentLoader>
    </div>
                
                <div v-if="cheapestLs.length!=0" class="">
                    <div id="flight-result-wrapper" class="dek-mt-80px" v-bind:class="{pull_down: isModifySearch}">

                        
                        <div class="d-flex package-lists">

                            <div class="left-flight-info-wrap mx-w-100">
                                <div class="top-flight-info no-scroll-card">
                                    <div v-for="(flightType,index) in cheapestLs"
                                         :key="'type'+flightType+index" class="pack-flight-wrap">
                                         <cSuggFlightResultCard :suggFlightLs="flightType" @onBooking="onBooking"></cSuggFlightResultCard>
                              
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        
     
   <div  class="">
            <div id="flight-result-wrapper" class="mt-25px">
                <div class="title individual-flight " style="padding-top: 0px;">


                    <div  id="scrollToDeparture" ref="scrollToDeparture" class="">
                      
                        <div  id="flight-result-wrapper">
                          



                         
        <div class="d-flex individual-flight" :class="{renNoflightwrap : !bindedFlightLs.ob}">
                                <div  class="left-flight-info-wrap">
                                    <div 
                                    class="mx-w-100 title individual-flight tik-t d-flex ai-center left-flight-info-wrap mt-0 " id="ft-1">
                                        <div class="left">
                                            <div v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0].to" class="main">

                                                {{$t("flightResults.departure")}}
                                                {{searchObj.route[0].from.depcode.city}}
                                                <span>{{searchObj.route[0].from.depcode.airportcode}}</span>
                                                {{$t("flightResults.to")}} {{searchObj.route[0].to.depcode.city}}
                                                <span>{{searchObj.route[0].to.depcode.airportcode}}</span>
                                                |
                                                {{searchObj.route[0].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                                            </div>
                                            <div class="sub">
                                                {{$t("flightResults.priceDesc")}}
                                            </div>

                                        </div>
                                        <div v-if="bindedFlightLs && (bindedFlightLs.ob || bindedFlightLs.ib)" class="right ml-auto">
                                            <div class="sort-wrapper">

                                                <div class="d-flex ai-center flex-flow-column text-left  ">
                                                    <div class="mr-15px">{{$t("flightResults.sortBy")}}</div>
                                                       <cSortDropDown
                                                   
                                                   :selValue="selObSortVal"
                                                   :ctrlName="'name'"
                                                   :ctrlCode="'code'"
                                                   :isShowCode="false"
                                                   v-on:input="getObSortedVal"
                                                  
                                                   class="inner-label-none"
                                           />

                                                </div>

                                            </div>
                                        </div>

                                    </div>
                           <div v-if="(searchObj &&  searchObj.trip==1? bindedFlightLs.ob == null:false) || 
                           (searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.obflights
                              && GET_SEARCH_RES.flight_results.obflights.length == 0  && bindedFlightLs.ib!=null:false)">
                          <cEmptyFlightRes :from="searchObj.route[0].from.depcode.city" 
                                            :to="searchObj.route[0].to.depcode.city" 
                                            :isNoFlights="false">

                          </cEmptyFlightRes>
                        
                          </div>

                          <div v-else-if="bindedFlightLs && bindedFlightLs.ob && bindedFlightLs.ob.length==0">
                          <cEmptyFlightRes :from="null" 
                                            :to="null" 
                                            :isNoFlights="false">

                          </cEmptyFlightRes>
                          </div>      
          <!-- <div class="no-flight-wrapper-depart"
          v-if="searchObj &&  searchObj.trip==1? bindedFlightLs.ob == null
         :false"
          show
          color="danger"
        ><img src="@imgPath/img/gif/nothing-found.gif" alt="">
            <div>{{ $t("flightResults.noDepartureFlights") }}</div></div>
                                 <div class="no-flight-wrapper-depart" v-if="searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.obflights
                              && GET_SEARCH_RES.flight_results.obflights.length == 0  && bindedFlightLs.ib!=null:false">
                                 
                                
                                <img src="@imgPath/img/gif/nothing-found.gif" alt="">
                                <div>{{ $t("flightResults.noDepartureFlights") }}</div>
                            </div> -->

                                  <!--  <div class="no-flight-wrapper-depart" v-if="bindedFlightLs && bindedFlightLs.ob && bindedFlightLs.ob.length==0">

                                        <img src="@imgPath/img/gif/nothing-found.gif" alt="">
                                        <div>There are no departure flights for the applied filters.</div>
                                    </div> -->

<!--                                    <div v-if="bindedFlightLs && bindedFlightLs.ob && bindedFlightLs.ob.length==0">-->
<!--                                      There are no departure flights for the applied filters.-->
<!--                                    </div>-->
                                    
                                    


                                    <div v-if="bindedFlightLs && bindedFlightLs.ob" class="top-flight-info">
                          <transition-group name="flip-list" tag="ul">
                    <div v-for="(obFlights,obFlightsindex) in bindedFlightLs.ob" :key="'ob'+obFlightsindex">
                        <div v-if="obFlights.length!=0"
                           class=""
                                  :class="getClassforALCard(obFlights)==true ? 'selected-flight':''" >

                                        <cFlightResultCard  :flightObj="obFlights[0].obFlight"  :totalFlightObj="obFlights"
                                     @updateflightls='updateSelFlightLs'/>
      
                                     
                              </div>
                          </div>
                              </transition-group>
                                  </div>
           
                      </div>

               <cEmptyFilter v-if="searchObj && (searchObj.trip==2 ? GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.obflights.length == 0 && bindedFlightLs.ib!=null:false)||
                              (searchObj&&searchObj.trip==1?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.obflights.length == 0:false)"></cEmptyFilter>
            <cAllFilterOb v-if=" bindedFlightLs.ob!=null 
                        && filterObWatchList"
              :filterObWatList="filterObWatchList"
              @cAllFilterOBFn="getAllObFilteredList"
             :isStopsForNonMyanmar="isStopsForNonMyanmar"
             :class="{'mobile_ob':isShowFilter_MWA_OB}"
            />
</div>
              </div>
      
        
                    </div>
                   
                    
      <div id="scrollToReturn" ref="scrollToReturn" class="">
                        <div  id="flight-result-wrapper" class="mt-25px">

                        </div>
                    </div>
     

          
             
        
                            
                <div class="d-flex individual-flight sty-foot-space" :class=" {depNoflightwrap : !bindedFlightLs.ib}">
                                <div v-if="searchObj && searchObj.trip==2 " class="left-flight-info-wrap">
                                    <div  class="mx-w-100 title individual-flight tik-t d-flex ai-center left-flight-info-wrap mt-0 " id="ft-2">
                                        <div class="left">
                                            <div v-if="searchObj&&searchObj.route&&searchObj.route.length>1&&searchObj.route[1]" class="main">
                                                {{$t("flightResults.arrival")}} {{searchObj.route[1].from.depcode.city}} <span>
                          {{searchObj.route[1].from.depcode.airportcode}}</span>
                                        {{$t("flightResults.to")}} {{searchObj.route[1].to.depcode.city}} <span>
                             {{searchObj.route[1].to.depcode.airportcode}}</span> |
                                        {{searchObj.route[1].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                                    </div>
                                    <div v-if="searchObj.route[1]" class="sub">
                                        {{$t("flightResults.priceDesc")}}
                                    </div>
                                </div>
                                <div v-if="searchObj && searchObj.trip==2 &&  bindedFlightLs && (bindedFlightLs.ob || bindedFlightLs.ib)" class="right ml-auto">
                                    <div class="sort-wrapper">

                                        <div v-if="searchObj && searchObj.trip==2 "
                                             class="d-flex ai-center  flex-flow-column text-left  ">                                            
                                            <div class="mr-15px">{{$t("flightResults.sortBy")}}</div>
                                            <cSortIbDropDown
                                                    
                                                    :selValue="selIbSortVal"
                                                    :ctrlName="'name'"
                                                    :ctrlCode="'code'"
                                                    :isShowCode="false"
                                                    v-on:input="getIbSortedVal"

                                                    class="inner-label-none"
                                            />

                                        </div>

                                    </div>
                                </div>

                            </div>
<!--                          <cFilterTag v-if="ibFilterTag.length!=0" @clearSelFilter="clearSelectedFilter" :dispFilterLs="ibFilterTag"></cFilterTag>-->

                              <div v-if="searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.ibflights && GET_SEARCH_RES.flight_results.ibflights.length == 0 && bindedFlightLs.ob!=null :false">
                          <cEmptyFlightRes :from="searchObj.route[1].from.depcode.city" 
                                            :to="searchObj.route[1].to.depcode.city" 
                                            :isNoFlights="false">

                          </cEmptyFlightRes>
                        
                          </div>

                          <div v-else-if="bindedFlightLs && bindedFlightLs.ib && bindedFlightLs.ib.length==0">
                          <cEmptyFlightRes :from="null" 
                                            :to="null" 
                                            :isNoFlights="false">

                          </cEmptyFlightRes>
                          </div> 


                          <!--  <div class="no-flight-wrapper-depart" v-if="searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.ibflights && GET_SEARCH_RES.flight_results.ibflights.length == 0 && bindedFlightLs.ob!=null :false">
                                 
                                <img src="@imgPath/img/gif/nothing-found.gif" alt="">
                                <div>{{ $t("flightResults.noArrivalFlights") }}</div>
                            </div>


                                    <div class="no-flight-wrapper-depart" v-if="bindedFlightLs && bindedFlightLs.ib && bindedFlightLs.ib.length==0">

                                        <img src="@imgPath/img/gif/nothing-found.gif" alt="">
                                        <div>There are no return flights for the applied filters.</div>
                                    </div>-->

<!--                            <div v-if="bindedFlightLs && bindedFlightLs.ib && bindedFlightLs.ib.length==0">-->
<!--                                -->
<!--                                      There are no return flights for the applied filters.-->
<!--                                    </div>-->
                            
                            <div v-if="bindedFlightLs && bindedFlightLs.ib&&bindedFlightLs.ib" class="top-flight-info">
                                <transition-group name="flip-list" tag="ul">
                                    <div v-for="(ibFlights,index) in bindedFlightLs.ib"
                                         :key="'ib'+index">

                                        <div v-if="ibFlights.length!=0"  class="" 
                                            :class="getClassforALCard(ibFlights)==true
                                                          ? 'selected-flight':''"
                                             >
                                            
                                                                   <cFlightResultCard  :flightObj="ibFlights[0].ibFlight" 
                           :totalFlightObj="ibFlights"  @updateflightls='updateSelFlightLs'/>    

                                           

                                        </div>
                                    </div>
                                </transition-group>
                            </div>
                        </div>


              <cEmptyFilter v-if="searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results 
                                && GET_SEARCH_RES.flight_results.ibflights
                              && GET_SEARCH_RES.flight_results.ibflights.length == 0 && bindedFlightLs.ob!=null:false">
                              </cEmptyFilter>
            <cAllFilterIb v-if="bindedFlightLs.ib!=null  && filterIbWatchList"
              :filterIbWatList="filterIbWatchList"
              
              @cAllFilterIBFn="getAllIbFilteredList"
              
             :isStopsForNonMyanmar="isStopsForNonMyanmar"
             :class="{'mobile_ib':isShowFilter_MWA_IB}"
            />
             
          </div>
        </div>
       
            </div>
           
            <CCol col="4" v-if="bindedFlightLs"></CCol>


            <CCol
                    col="12"
                    v-if="
        bindedFlightLs
      ">

            </CCol>
           
               
                   </div> 
  
                </div>
            
                <cFlightFooter v-if="bindedFlightLs&&selFlight&&(selFlight.ob || selFlight.ib)" :isSticky="true"
                                :isFlightSel="selFlight && selFlight.ob!=null || selFlight && selFlight.ib!=null"
                               :isDisable="toDisableContinueButton()" :buttonName="$t('flightResults.continue')"
                               :selFlight="selFlight" :type="false"
                               @onContinue="OnContinue" @RemoveclassofFlight="toRemoveSelectableClass"/>

                <div class="filter-back-drop" v-if="isShowFilter_MWA">
                    <div class="close" @click="  clearMWAfilters()">

                    </div>
                  <button   :class="{'active':isShowFilter_MWA_OB}" @click="isShowFilter_MWA_OB=true,isShowFilter_MWA_IB=false"> Departure </button>
                  <button  :class="{'active':isShowFilter_MWA_IB}" @click="isShowFilter_MWA_IB=true,isShowFilter_MWA_OB=false"> Return </button>
                    <button v-if="isShowFilter_MWA_OB || isShowFilter_MWA_IB " class="apply-btn" @click=" clearMWAfilters()">
                        {{$t('flightResults.apply')}}
                    </button>
                </div>         
                <div  class="filter-mob-icon" @click="toggleFilter(),addCssClassFilter(true)">

                    <div v-if="!isMobile" class="icon">

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             style="fill:white;">
                            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
                        </svg>
                    </div>
                    <div v-else>
        <ion-fab-button>
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
      </div>
                </div>

            </div>       
</template>

<script>
import cAllFilterOb from "../../../../../components/result/cAllFilterOb";
import cAllFilterIb from "../../../../../components/result/cAllFilterIb";
// import cFilterTag from "../../../../components/result/cFilterTag";
import cSortIbDropDown from "../../../../../components/sort/cSortIbDropDown";
import { ContentLoader } from "vue-content-loader";
import cSortDropDown from "../../../../../components/sort/cSortDropDown";

import { cloneData,scrollToTop,cloneDeep } from "../../../../../util/util.js";
import cEmptyFlightRes from "../../../../../components/result/cEmptyFlightRes"
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import cSearch from "../../../../../components/search/cSearch";
// import cPerPaxPriceInfo from "../../../../components/result/cPerPaxPriceInfo";
// import cTotalPriceInfo from "../../../../components/result/cTotalPriceInfo";
// import cSelFlightInfo from "../../../../components/result/cSelFlightInfo";
import cFlightFooter from "../../../../../components/result/cFlightFooter";
import BaseConfiguration from "../../../../../config/base.js";
import cFlightResultCard from "../../../../components/result/cFlightResultCard";
import cSuggFlightResultCard from "../../../../../components/result/cSuggFlightResultCard";
import cEmptyFilter from "../../../../../components/result/cEmptyFilter";
import cResultContentLoader from "../../../../../components/result/cResultContentLoader";
import Logger from "../../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../../config/API_DATA";

import router, {
  navigate,
  goBack,
  updateCurrRouteQuery,
  updateDataEdited
} from "../../../../../router/index";
import {
  SORT,
  ORDER,
  COMPONENT_NAME,
  PATHNAME,
  TRIP,
  TOAST_TYPE,
  ROUTER_PARAM,
  FILTER,
  BOUND_TYPE,
  FLIGHT_SELECTION_STATUS,
  DATE_TIME_FORMAT
} from "../../../../../util/constants";
import { getDiffBtwDates,differnceofDates, formatDate } from "../../../../../util/date/dateFunctions";
import { mapGetters, mapActions } from "vuex";
import apiSearchResult from "../../../../../services/apiSearchResult.js";
import apiPricingSearch from "../../../../../services/apiPricingSearch.js";
import {oneWayRecommended , twoWayRecommended} from "../../../../../pages/booking/flight/chepestFlight.js";

import { handleJWT, getErrorAlertValue, groupBy ,addClassToBody, OrderByList, removeClassBody,handleSessionExist} from "../../../../../util/util";
import { is } from 'vee-validate/dist/rules';
export default {
  name: COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
  components: {
    cSearch,
    cSortDropDown,
    cSortIbDropDown,
    // cPerPaxPriceInfo,
    // cTotalPriceInfo,
    // cSelFlightInfo,
    cFlightFooter,
   cFlightResultCard,
    ContentLoader,
    cAllFilterOb,
    // cFilterTag,
    cEmptyFlightRes,
    cAllFilterIb,
    cResultContentLoader,
    cSuggFlightResultCard,
    cEmptyFilter
  },
  data: () => ({
  //  bindedFlightLs:null,
    isShowFilter_MWA_OB:false,
    isShowFilter_MWA_IB:false,
    selFlight: {
      ob:null,
      ib: null},
    selIbSortVal: null,
    selObSortVal: null,
    filterObWatchList:null,
    filterIbWatchList:null,
    isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
    noOfMaxFare: BaseConfiguration.maxFareList,
    relevantOBCount: 0,
    relevantIBCount: 0,
    sessionId: null,
    alertValue: null,
    routesObj: null,
    searchObj: null,
    isModifySearch: false,
    obStops:[],
    ibStops:[],
    flightAlert:null,
    isLoading:true,
    noClass:FLIGHT_SELECTION_STATUS.noClass,
    selectedClass:FLIGHT_SELECTION_STATUS.selected,
    selectableClass:FLIGHT_SELECTION_STATUS.selectable,
    disableClass:FLIGHT_SELECTION_STATUS.disable,
    showAlert:false,
    cheapestLs:[],
    isShowFilter_MWA : false, //MWA-MobileWebApp, for small devices. Handling responsive web page
    obFilterTag:[],
    ibFilterTag:[],
    selIbFilterItems:null,
    selObFilterItems:null,
    isMobile: BaseConfiguration.isMobile
  
   
  }),




  methods: {
    ...mapActions("sPaxPage", {
      CLEAR_PAX_STORE: "CLEAR_PAX_STORE"
    }),
    ...mapActions("sCSearch", {
      SET_SEARCH_OBJ: "SET_SEARCH_OBJ",
      //CLEAR_CSEARCH_STORE: "CLEAR_CSEARCH_STORE",
    }),
...mapActions("sMLResult", {
      CLEAR_ML_RESULT_STORE: "CLEAR_ML_RESULT_STORE",
}),
  // ...mapActions("sCMultiCitySearch", {
  //     SET_IS_MODIFY_SEARCH: "SET_IS_MODIFY_SEARCH"

  //   }),
    ...mapActions("sResult", {
      CLEAR_RESULT_STORE:"CLEAR_RESULT_STORE",
      SET_CHEAPESTLS:"SET_CHEAPESTLS",
      SET_ORG_BINDED_FLIGHT_LS:"SET_ORG_BINDED_FLIGHT_LS",
      SET_IB_SEL_SORT_OBJ:"SET_IB_SEL_SORT_OBJ",
     SET_OB_SEL_SORT_OBJ:"SET_OB_SEL_SORT_OBJ",
      SET_OB_FILTER_DATA: "SET_OB_FILTER_DATA",
      SET_IB_FILTER_DATA: "SET_IB_FILTER_DATA",
      SET_OB_FLIGHT_OBJ: "SET_OB_FLIGHT_OBJ",
      SET_IB_FLIGHT_OBJ: "SET_IB_FLIGHT_OBJ",
      SET_SEL_SORT_OBJ: "SET_SEL_SORT_OBJ",
      
      SET_SEL_PRICING_OBJ: "SET_SEL_PRICING_OBJ",
      SET_SEL_FLI_FRM_PRIC: "SET_SEL_FLI_FRM_PRIC",
      SET_AIRLINES: "SET_AIRLINES",
      SET_AIRPORTS: "SET_AIRPORTS",
      SET_CURRENCY: "SET_CURRENCY",
      SET_SEARCH_PRICING_REQ:'SET_SEARCH_PRICING_REQ',
      SET_SEARCH_RES:'SET_SEARCH_RES',      
      SET_BINDED_FLIGHT_LS: 'SET_BINDED_FLIGHT_LS',
            SET_SELFLIGHT_FOR_FOOTER:"SET_SELFLIGHT_FOR_FOOTER"

    }),


    clearMWAfilters() {
        try {
          if(BaseConfiguration.isDebug) console.log("myFunctionName");
             this.isShowFilter_MWA=false;
             this.isShowFilter_MWA_OB=false;
             this.isShowFilter_MWA_IB=false;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in clearMWAfilters",
                  err.toString(),
                  "clearMWAfilters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    
    toggleFilter(){
      this.isShowFilter_MWA = !this.isShowFilter_MWA;

    },
    addCssClassFilter(isOB){
      if(isOB)
        this.isShowFilter_MWA_OB = !this.isShowFilter_MWA_OB;
      else
        this.isShowFilter_MWA_IB = !this.isShowFilter_MWA_IB;
    },
  

   ///to get filtered ob airlines 
    filterAL(pObFlights,pSelAL,isOb) {
     
      let retValue=[];
      
        try {
          if(BaseConfiguration.isDebug) console.log("filterAL");
          for(let index=0;index<pSelAL.length;index++){
            
            for (var i in pObFlights) {
              let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
              if(pSelAL[index].by=='user') {
              if(pSelAL[index].status==1) {
                for (let j = 0; j < flights.length; j++) {
                  if(pSelAL[index].code==flights[j].flight.opAirline) {
                    if(!retValue.includes(pObFlights[i])) {
                     retValue.push(pObFlights[i]);
                    }
                  }
                }
            // if(pSelAL[index].code==flights[0].flight.opAirline) {
            //   retValue.push(pObFlights[i]);
            // }
            
              } 
            }
          
            
          }
          
          
          }
         
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_AL,
                  "error in filterAL",
                  err.toString(),
                  "filterAL",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
 }, 

  ///to get filtered ob airlines 
    filterDepTime(pObFlights,pSelDepTime,isOb) {
     
      let retValue=[];
      
        try {
          if(BaseConfiguration.isDebug) console.log("filterDepTime");
          for(let index=0;index<pSelDepTime.length;index++){
            if(pObFlights.length!=0){
            for (var i in pObFlights) {
              let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
              if(pSelDepTime[index].by=='user') {
              if(pSelDepTime[index].status==1) {
                if(pSelDepTime[index].start<=formatDate(flights[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) && 
            pSelDepTime[index].end>=formatDate(flights[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT))
            {
              retValue.push(pObFlights[i]);
            }} }}
          
            }
          }
         
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_DEPTIME,
                  "error in filterDepTime",
                  err.toString(),
                  "filterDepTime",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
 }, 

  

///to get filtered stops
filterObFlights(pObFlights, pSelStop, isOb) {
  
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("filterObFlights");

       
        for (var i in pObFlights) {
          let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
          
          for (let j = 0; j < pSelStop.length; j++) {
            if (
              pSelStop[j].code == flights.length - 1
            ) {
              retValue.push(pObFlights[i]);
            }
          }
            
       
        
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_FILTER_STOPS_OB,
          "error in filterObFlights",
          err.toString(),
          "filterObFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

///to get filtered via obj
viaFilter(pObFlights, pSelStop, isOb) {
  
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("viaFilter");

    
        for (var i in pObFlights) {
         if(pObFlights[i].length!=0){
          let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
          for (let j = 0; j < pSelStop.length; j++) {
            
             
              if(pSelStop[j].status==1) {
            if (pSelStop[j].code >= flights[0].flight.no_of_viaObj.code) {
              retValue.push(pObFlights[i]);
             
            }
              }
          }}
        }
        
       
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_FILTER_VIA,
          "error in viaFilter",
          err.toString(),
          "viaFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
 },

 ///to get filtered stop obj
stopFilter(pObFlights, pSelStop, isOb) {
  
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("stopFilter");

    
        for (var i in pObFlights) {
         if(pObFlights[i].length!=0){
          let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
          for (let j = 0; j < pSelStop.length; j++) {
            
             
              if(pSelStop[j].status==1) {
            if (pSelStop[j].code >= flights[0].flight.no_of_stops.code) {
              retValue.push(pObFlights[i]);
             
            }
              }
          }}
        }
        
       
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_FILTER_VIA,
          "error in stopFilter",
          err.toString(),
          "stopFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
 },

    ///to get filtered ob flights based on price

filterPrice(pObFlights,pSelPrice) {
    
      let retFilPriceLs=[];
    
        try {
          if(BaseConfiguration.isDebug) console.log("filterPrice");
         
         if(pSelPrice && pObFlights){
            
        
            for(let j=0;j<pObFlights.length;j++){

            if(pSelPrice.by=='user')
             { 
               if(pObFlights[j].clientPricing.AdultPrice.Total>=pSelPrice.from&&
             pObFlights[j].clientPricing.AdultPrice.Total<=pSelPrice.to)
            {
              
              retFilPriceLs.push(pObFlights[j]);
            }
             }
            else{
              if(pObFlights[j].clientPricing.AdultPrice.Total>=pSelPrice.min&&
             pObFlights[j].clientPricing.AdultPrice.Total<=pSelPrice.max)
            {
              
              retFilPriceLs.push(pObFlights[j]);
            }
            }
      


            }
          
          
         }
        
   return retFilPriceLs;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_AL,
                  "error in filterPrice",
                  err.toString(),
                  "filterPrice",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
     
},

///to get filtered ob flights based on price

 filterDuration(pObFlights,pSelDuration,isOb) {
    
      let retVal=[];
    
        try {
          if(BaseConfiguration.isDebug) console.log("filterDuration");
        

     
        for (var i in pObFlights) {
         if(pObFlights[i].length!=0){
          let flights = isOb ? pObFlights[i][0].obFlight: pObFlights[i][0].ibFlight;
               if(pSelDuration.by=='user')
             { 
               if(flights[0].flight.TotalDuration>=pSelDuration.from&&
            flights[0].flight.TotalDuration<=pSelDuration.to)
            {
              
              retVal.push(pObFlights[i]);
            }
             }
            else{
              if(flights[0].flight.TotalDuration>=pSelDuration.start&&
             flights[0].flight.TotalDuration<=pSelDuration.end)
            {
              
              retVal.push(pObFlights[i]);
            }
            }
         
          }
        }
        
       
        
   return retVal;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_DUR,
                  "error in filterDuration",
                  err.toString(),
                  "filterDuration",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
     
},
              ///callBack function which returns property value to sort
    getIbPropToSort(pFlightObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getIbPropToSort");
      if (
        this.selIbSortVal.code == SORT.LOWEST_PRICE ||
        this.selIbSortVal.code == SORT.HIGHEST_PRICE
      ) {
        if (pFlightObj.clientPricing != null) {
          return pFlightObj.clientPricing.AdultPrice.Total;
        }
        else {
          for (let i = 0; i < pFlightObj.length; i++) {
            return pFlightObj[i].clientPricing.AdultPrice.Total;
          }
        }
      } else if (this.selIbSortVal.code == SORT.EARLIEST_DEP) {
       
         
          if (pFlightObj.length!=0 && pFlightObj[0].ibFlight[0].flight.DepDate != null) {
            return pFlightObj[0].ibFlight[0].flight.DepDate;
          }
         
        
      } else if (this.selIbSortVal.code == SORT.EARLIEST_ARR) {

          
          if (pFlightObj.length!=0 && pFlightObj[0].ibFlight[pFlightObj[0].ibFlight.length-1].flight.ArrDate != null) {
            return pFlightObj[0].ibFlight[pFlightObj[0].ibFlight.length-1].flight.ArrDate;
        
          
        }
      }else if (this.selIbSortVal.code == SORT.SHORTEST_DUR) {
       
          
          if (pFlightObj.length!=0 && pFlightObj[0].ibFlight[0].flight.TotalDuration != null) {
            return pFlightObj[0].ibFlight[0].flight.TotalDuration;
          }
         
        
      }
      }
      catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error in getIbPropToSort",
          err.toString(),
          "getIbPropToSort",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


        ///callBack function which returns property value to sort
    getObPropToSort(pFlightObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getObPropToSort");
      if (
        this.selObSortVal.code == SORT.LOWEST_PRICE ||
        this.selObSortVal.code == SORT.HIGHEST_PRICE
      ) {
        if (pFlightObj.clientPricing != null) {
          return pFlightObj.clientPricing.AdultPrice.Total;
        }
        else {
          for (let i = 0; i < pFlightObj.length; i++) {
            return pFlightObj[i].clientPricing.AdultPrice.Total;
          }
        }
      } else if (this.selObSortVal.code == SORT.EARLIEST_DEP) {
       

          if (pFlightObj.length!=0 && pFlightObj[0].obFlight[0].flight.DepDate != null) {
            return pFlightObj[0].obFlight[0].flight.DepDate;
          }
          
       
      } else if (this.selObSortVal.code == SORT.EARLIEST_ARR) {
        
         
          if (pFlightObj.length!=0 && pFlightObj[0].obFlight[pFlightObj[0].obFlight.length-1].flight.ArrDate != null) {
            return pFlightObj[0].obFlight[pFlightObj[0].obFlight.length-1].flight.ArrDate;
          }
          
       
      }else if (this.selObSortVal.code == SORT.SHORTEST_DUR ) {
        
         
          if (pFlightObj.length!=0 && pFlightObj[0].obFlight[0].flight.TotalDuration != null) {
            return pFlightObj[0].obFlight[0].flight.TotalDuration;
          }
          
       
      }
      }
      catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error in getObPropToSort",
          err.toString(),
          "getObPropToSort",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    
    ///to sort by price(asc/desc)
    sortByPrice(pOrder,pBindedObFlightLs,isOb) {
     
      try {
        if (BaseConfiguration.isDebug) console.log("sortByPrice");

        let lsSortByPrice = pBindedObFlightLs;
        let obflights = Object.values(lsSortByPrice);
        if (obflights != null) {
        for (let i = 0; i < obflights.length; i++) {
          if(isOb) {
            var lsOBSortByPrice = OrderByList(
            obflights[i],
            this.getObPropToSort, 
            pOrder
          );
          }else{
             var lsOBSortByPrice = OrderByList(
            obflights[i],
            this.getIbPropToSort,
            pOrder
          );
          }
          obflights[i]=lsOBSortByPrice;
          lsSortByPrice=obflights;
        }
        if(isOb){
         var lsOBSort = OrderByList(
            lsSortByPrice,
            this.getObPropToSort,
            pOrder
          );
        }else{
           var lsOBSort = OrderByList(
            lsSortByPrice,
            this.getIbPropToSort,
            pOrder
          );
        }
          lsSortByPrice=lsOBSort;
        
        }
        

        return lsSortByPrice;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error while sorting",
          err.toString(),
          "sortByPrice",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to sort by Arrival Date(asc/desc)
    sortByArrDate(pOrder,pBindedObFlightLs,isOb) {
      try {
        if (BaseConfiguration.isDebug) console.log("soryByArrDate");

        let lsSortByArrDate = pBindedObFlightLs;
        let obflights = Object.values(lsSortByArrDate);
     
    
        if (obflights != null) {
         
         if(isOb) {
            var lsOBSortByArrDate = OrderByList(
            obflights,
            this.getObPropToSort,
            pOrder
          );
         }else{
            var lsOBSortByArrDate = OrderByList(
            obflights,
            this.getIbPropToSort,
            pOrder
          );
         }
          lsSortByArrDate=lsOBSortByArrDate;
        
        }
        
        return lsSortByArrDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error while sorting",
          err.toString(),
          "soryByArrDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to sort by Departure date(asc/desc)
    sortByDepDate(pOrder,pBindedObFlightLs,isOb) {
      try {
        if (BaseConfiguration.isDebug) console.log("sortByDepDate");
        let lsSortByDepDate = pBindedObFlightLs;
        let obflights = Object.values(lsSortByDepDate);
      

        if (obflights != null) {
        if(isOb){
        
            var lsOBSortByDepDate = OrderByList(
            obflights,
            this.getObPropToSort,
            pOrder
          );
        }else{
           var lsOBSortByDepDate = OrderByList(
            obflights,
            this.getIbPropToSort,
            pOrder
          );
        }
         lsSortByDepDate=lsOBSortByDepDate;
        }
       
        return lsSortByDepDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error while sorting",
          err.toString(),
          "sortByDepDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to sort by Duration(asc/desc)
    sortByDuration(pOrder,pBindedObFlightLs,isOb) {
      try {
        if (BaseConfiguration.isDebug) console.log("sortByDuration");
        let lsSortByDuration = pBindedObFlightLs;
        let obflights = Object.values(lsSortByDuration);
      

        if (obflights != null) {
       if(isOb)
         {
          var lsOBSortByDuration = OrderByList(
            obflights,
            this.getObPropToSort,
            pOrder
          );
         }else{
            var lsOBSortByDuration = OrderByList(
            obflights,
            this.getIbPropToSort,
            pOrder
          );
         }
          lsSortByDuration=lsOBSortByDuration;
         
        }

      
        return lsSortByDuration;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
          "error while sorting",
          err.toString(),
          "sortByDuration",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     
    
///on Booking the combined flights

    onBooking(pFlight) {
        try {
          if(BaseConfiguration.isDebug) console.log("onBooking");
          if(pFlight.length==1){
            this.assignObSelFlight(pFlight[0]);
          }
          else{
            for (let i = 0; i < pFlight.length; i++) {
              
              if(pFlight[i].obFlight) {
              this.assignObSelFlight(pFlight[i]);
            }else if(pFlight[i].ibFlight) {
              this.assignIbSelFlight(pFlight[i]);
            }
            }
            
          }
          if(this.searchObj.trip==TRIP.ONE_WAY && this.selFlight.ob!=null){
            this.OnContinue();
          }
          else if(this.searchObj.trip==TRIP.ROUND_TRIP && this.selFlight.ob!=null && this.selFlight.ib!=null) {
            this.OnContinue();
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in onBooking",
                  err.toString(),
                  "onBooking",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
  }, 

  



///get cheapest, quickest , best flight result
 getCheapestFile(pFlightRes) {
      let retValue=[];
        try {
          if(BaseConfiguration.isDebug) console.log("getCheapestFile");
          if (this.searchObj.trip == TRIP.ONE_WAY) {
          retValue=oneWayRecommended(pFlightRes);
          }
          else 
          if(this.searchObj.trip == TRIP.ROUND_TRIP) {
             retValue=twoWayRecommended(pFlightRes);
          }

         
         
         
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in getCheapestFile",
                  err.toString(),
                  "getCheapestFile",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
  }, 

    ///functionality on click of continue button
    OnContinue() {
               
               try {
                 if(BaseConfiguration.isDebug) console.log("OnContinue");
                 
                // addClassToBody('Loading');
                 this.onSelectPricing();
                
               } catch (err) {
                       let body = Logger.buildRequest(
                         FILE_NAME.TOUR_FLIGHT_RESULTS,
                         "error in OnContinue",
                         err.toString(),
                         "OnContinue",
                         LOG_TYPE.ERROR
                       );
                       Logger.getResponse(body);
                     }
                 
     }, 
     

    /// to prevent the click functionality 
    click (e) {
    	e.preventDefault();
    },

//to get all filtered list values of OB
    getAllObFilteredList(pFilterWatchList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getAllObFilteredList");
        
        this.filterObWatchList = pFilterWatchList;
    
       
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in getAllObFilteredList",
          err.toString(),
          "getAllObFilteredList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

//to get all filtered list values of IB
    getAllIbFilteredList(pFilterIBWatchList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getAllIbFilteredList");
        
       
       
        this.filterIbWatchList = pFilterIBWatchList;
        
        
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in getAllIbFilteredList",
          err.toString(),
          "getAllIbFilteredList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    formatSelPricingObj(pSelectedPricing, pSearchObj) {
      let retValue = cloneDeep(this.selFlight);
      if(retValue){
        if(retValue.ob&&retValue.ob.clientPricing){
          retValue.ob.clientPricing=null;
           
        }
        if(retValue.ib&&retValue.ib.clientPricing){
         retValue.ib.clientPricing=null;
        }
       
      }
     
      ///the select pricing api has 2 types of results(pUnits with length 0 and length 1)
         if(pSelectedPricing&&pSelectedPricing.pUnits.length>0){///if any cases,(pUnits with length 0 or length 1 or )
           for(let i=0;i<pSelectedPricing.pUnits.length;i++){
              if(pSelectedPricing.pUnits[i].hasOwnProperty(BOUND_TYPE.IB)){//check whether it has ob or not
               retValue.ib.ibFlight = pSelectedPricing.pUnits[i].ibFlight;
               if(pSelectedPricing.pUnits[i].hasOwnProperty('clientPricing')&&pSelectedPricing.pUnits.length!=1){
                retValue.ib.clientPricing=pSelectedPricing.pUnits[i].clientPricing;

               }
              }
              if(pSelectedPricing.pUnits[i].hasOwnProperty(BOUND_TYPE.OB)){//check whether it has ib or not
                   retValue.ob.obFlight = pSelectedPricing.pUnits[i].obFlight;
                  
                    if(pSelectedPricing.pUnits[i].hasOwnProperty('clientPricing')){
                retValue.ob.clientPricing=pSelectedPricing.pUnits[i].clientPricing;

               }
              }
           }
          //  if(pSelectedPricing.pUnits.length>1){
          
          //  }

          if(pSearchObj.trip==TRIP.ONE_WAY){
                    retValue.ob=this.assigningFlightProp(retValue.ob,true);

              }else{
                 retValue.ob=this.assigningFlightProp(retValue.ob,true);
              retValue.ib=this.assigningFlightProp(retValue.ib,false)
                }
                if(pSelectedPricing.pUnits.length>1){
                   this.SET_SELFLIGHT_FOR_FOOTER(cloneDeep(retValue));

                }

                  if(pSelectedPricing.hasOwnProperty('summary')){
      if(pSelectedPricing.summary.hasOwnProperty('pricingSummary'))
      {
        if(pSelectedPricing.summary.pricingSummary.constructor==Array&&pSelectedPricing.summary.pricingSummary[0].isTotal)//if List
        {
           retValue.ob.clientPricing.isTotal=pSelectedPricing.summary.pricingSummary[0].isTotal;
      retValue.ob.clientPricing.TotalTax =
        pSelectedPricing.summary.pricingSummary[0].Tax;
      retValue.ob.clientPricing.TotalBaseFare =
        pSelectedPricing.summary.pricingSummary[0].BaseFare;
      retValue.ob.clientPricing.TotalAmount =
        pSelectedPricing.summary.pricingSummary[0].Total;
        retValue.ob.clientPricing.isTotal =
        pSelectedPricing.summary.pricingSummary[0].isTotal;
        
        if(retValue.ib&&retValue.ib.clientPricing)
        {
       retValue.ib.clientPricing.TotalTax =0;
      retValue.ib.clientPricing.TotalBaseFare =0;
       
      retValue.ib.clientPricing.TotalAmount =0;
         retValue.ib.clientPricing.isTotal =
        false;
        }
      
       
      }else{//if Object
           retValue.ob.clientPricing.isTotal=pSelectedPricing.summary.pricingSummary.isTotal;

        retValue.ob.clientPricing.TotalTax =
        pSelectedPricing.summary.pricingSummary.Tax;
      retValue.ob.clientPricing.TotalBaseFare =
        pSelectedPricing.summary.pricingSummary.BaseFare;
      retValue.ob.clientPricing.TotalAmount =
        pSelectedPricing.summary.pricingSummary.Total;
          retValue.ob.clientPricing.isTotal =
        pSelectedPricing.summary.pricingSummary.isTotal;

        if(retValue.ib&&retValue.ib.clientPricing)
        {
       retValue.ib.clientPricing.TotalTax =0;
      retValue.ib.clientPricing.TotalBaseFare =0;
       
      retValue.ib.clientPricing.TotalAmount =0;
       retValue.ib.clientPricing.isTotal =
        false;
        }
      }
      }

            //to assign currency
      if(pSelectedPricing.hasOwnProperty('currency')){
        if(pSelectedPricing.currency.code)
        {
         retValue.ob.clientPricing.Currency = pSelectedPricing.currency.code;
        }
      }
                  }
       if(!(pSelectedPricing.pUnits.length>1)) {
     this.SET_SELFLIGHT_FOR_FOOTER(cloneDeep(retValue));

       }
      
  //      ///assigning the whole clientPricing to OB from summary(because,ib and ob has no property of client pricing)
  //    if( !(pSearchObj.trip==TRIP.ROUND_TRIP?(retValue.ib.hasOwnProperty('clientPricing')&&retValue.ib.clientPricing):true&&(retValue.ob.hasOwnProperty('clientPricing')&&retValue.ob.clientPricing)))
  //    {
  //     if(pSelectedPricing.hasOwnProperty('summary')){
  //     if(pSelectedPricing.summary.hasOwnProperty('pricingSummary'))
  //     {
  //       if(pSelectedPricing.summary.pricingSummary.constructor==Array)//if List
  //       {
  //     retValue.ob.clientPricing.TotalTax =
  //       pSelectedPricing.summary.pricingSummary[0].Tax;
  //     retValue.ob.clientPricing.TotalBaseFare =
  //       pSelectedPricing.summary.pricingSummary[0].BaseFare;
  //     retValue.ob.clientPricing.TotalAmount =
  //       pSelectedPricing.summary.pricingSummary[0].Total;
  //     }else{//if Object
  //       retValue.ob.clientPricing.TotalTax =
  //       pSelectedPricing.summary.pricingSummary.Tax;
  //     retValue.ob.clientPricing.TotalBaseFare =
  //       pSelectedPricing.summary.pricingSummary.BaseFare;
  //     retValue.ob.clientPricing.TotalAmount =
  //       pSelectedPricing.summary.pricingSummary.Total;
  //     }
  //     }

  //           //to assign currency
  //     if(pSelectedPricing.hasOwnProperty('currency')){
  //       if(pSelectedPricing.currency.code)
  //       {
  //        retValue.ob.clientPricing.Currency = pSelectedPricing.currency.code;
  //       }
  //     }
  //             ///to assign adult Price
  //     if (pSearchObj.pax.adultCount > 0) {
  //       if(pSelectedPricing.summary.hasOwnProperty('AdultTotal'))
  //       {
  //       retValue.ob.clientPricing.AdultPrice =
  //         pSelectedPricing.summary.AdultTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.AdultPrice = null;
  //     }

  //         ///to assign child price
  //     if (pSearchObj.pax.childCount > 0) {
  //        if(pSelectedPricing.summary.hasOwnProperty('ChildTotal'))
  //       {
  //       retValue.ob.clientPricing.ChildPrice =
  //         pSelectedPricing.summary.ChildTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.ChildPrice = null;
  //     }
  //     ///to assign infant price
  //     if (pSearchObj.pax.infantCount > 0) {
  //         if(pSelectedPricing.summary.hasOwnProperty('InfantTotal'))
  //       {
  //       retValue.ob.clientPricing.InfantPrice =
  //         pSelectedPricing.summary.InfantTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.InfantPrice = null;
  //     }

  //           //assigning null to ib,because we have assigned whole summary to ob(ob-(common) will come from both OneWay and TwoWay)
  //       if( retValue.ib){
  //          retValue.ib.clientPricing=null;
  //       }

  //    }

  //  }
          }
      
    
      return retValue;
    },


/// to check the selected filghts is valid/ not on continue
    isValidSelFlights(pSelFlight) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("isValidSelFlights");
         if(pSelFlight.ob && pSelFlight.ib){
           if(pSelFlight.ob.hasOwnProperty('matchingId') && pSelFlight.ib.hasOwnProperty('matchingId'))
             {
               for (let index = 0; index < pSelFlight.ib.matchingId.length; index++) {
                 if(pSelFlight.ob.pId==pSelFlight.ib.matchingId[index]) {
                   retValue=true;
                   break;
                 }
                 else{
                   retValue= false;
                 
                 }
                 }

             }
             else if(!pSelFlight.ob.hasOwnProperty('matchingId') && !pSelFlight.ib.hasOwnProperty('matchingId')){
               retValue=true;
             }
             else if((pSelFlight.ob.hasOwnProperty('matchingId') && !pSelFlight.ib.hasOwnProperty('matchingId')) ||
                    (!pSelFlight.ob.hasOwnProperty('matchingId') && pSelFlight.ib.hasOwnProperty('matchingId'))) {
                retValue= false;
                  
             }}
             else if(pSelFlight.ob) {
               retValue=true;
             }
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in isValidSelFlights",
                  err.toString(),
                  "isValidSelFlights",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
 }, 

 ///api call on continue
    async onSelectPricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelectPricing");
                updateDataEdited(false);

        if (!this.toDisableContinueButton()) {
          let isRelSel=false;
        
          isRelSel=this.isValidSelFlights(this.selFlight);
          if(isRelSel) {

          let pricingRes = await this.getPricingSearch(
            this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID], //get session id from url
            this.selFlight
          );
          if (pricingRes) {
            // let selectedPricing=this.sSelectedPricing;
           
            let retSelFlight = this.formatSelPricingObj(
              pricingRes,
              this.searchObj
            );
            if (retSelFlight) {
              //  this.selFlight = retSelFlight;

              this.SET_SEL_FLI_FRM_PRIC(retSelFlight);
              this.goToPaxInfo();
            }
            
              }
            }
          } 
         
       
        
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in onSelectPricing",
          err.toString(),
          "onSelectPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get pricing search  from api
    async getPricingSearch(pSessionId, pSelFlight) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingSearch");
        
        let pricingSearchReq = apiPricingSearch.buildRequest(
          pSessionId,
          pSelFlight
        );

        if (pricingSearchReq) {
     this.SET_SEARCH_PRICING_REQ(pricingSearchReq)
           
          let pricingSearchRes = await apiPricingSearch.getResponse(
            pricingSearchReq
          );

          if (VALIDATE_SUCCESS_RES(pricingSearchRes)) {
            this.SET_SEL_PRICING_OBJ(pricingSearchRes);
            retValue = pricingSearchRes.data.data;
            
            if(BaseConfiguration.isDebug)
            {
           for(let i=0;i<retValue.pUnits.length;i++){
            console.log(retValue.pUnits[i].pId);
           }
            }

          } else {
            addClassToBody(COMPONENT_NAME.TOUR_FLIGHT_RESULTS);
            //  let s={"status":"Error","error":[{"code":"SES03","value":"session not exist\r\n"}]};
            let error = getErrorMessage(pricingSearchRes);
            
             
        
        let isJwt = handleJWT(error);
            if (!isJwt && pricingSearchRes) {
                          let isSessionExpired= handleSessionExist(pricingSearchRes.data);
              if(!isSessionExpired)
              {
                  let alertValue = getErrorAlertValue(error);
                  // this.showToast(null, TOAST_TYPE.CLEAR);

              // this.showToast(
              //       alertValue,//this.$t("flightResults.fliResFailed"),
              //       TOAST_TYPE.ERROR,
              //       5000,
              //       null
              //     );
              
              }
              
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in getting response from get pricing search response API",
          err.toString(),
          "getPricingSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    // update Flights with status
    updateSelFlightLs(pUnit) {
      let retValue = null;
      let SelFlight={
        ob:null,
       ib:null
      }
     
      try {
        if (BaseConfiguration.isDebug) console.log("updateSelFlightLs" + pUnit.pId);

        if (pUnit && pUnit.obFlight) {
         
             updateDataEdited(true);
           retValue = this.onObSelFlight(pUnit, this.bindedFlightLs);
        } else if (pUnit && pUnit.ibFlight) {
           updateDataEdited(true);
          retValue = this.onIbSelFlight(pUnit, this.bindedFlightLs);
          
        }
        else{
          SelFlight=null;
        }
        
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in updateSelFlightLs",
          err.toString(),
          "updateSelFlightLs",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///scroll into view
 scrollToElement(pRef) {
       var el = null;
       if(pRef == 'scrollToReturn') {
     el = this.$refs.scrollToReturn;
       }else{
          el= this.$refs.scrollToDeparture;
       }
      
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
  },
  
    /// assigning selected ob flight
  assignObSelFlight(pSelFlights) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("assignObSelFlight");
          if(pSelFlights) {
            retValue =  pSelFlights;
          }
          else{
             retValue=  null;
          }
         this.selFlight.ob=retValue;
         
         this.SET_OB_FLIGHT_OBJ(this.selFlight.ob);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignObSelFlight",
                  err.toString(),
                  "assignObSelFlight",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

///assigning selected ib flight
    assignIbSelFlight(pSelFlights) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("assignIbSelFlight");
       if(pSelFlights) {
         retValue = pSelFlights;
       }
       else{
         retValue = null;
       }
       
       this.selFlight.ib=retValue;
      
      this.SET_IB_FLIGHT_OBJ(this.selFlight.ib);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignIbSelFlight",
                  err.toString(),
                  "assignIbSelFlight",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
 }, 

    // ob selected flights
    onObSelFlight(pFlight, pFlightObj) {
     
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("onObSelFlight");
        
        if (pFlight && this.searchObj && this.searchObj.trip) {
          if (this.searchObj.trip == TRIP.ONE_WAY) {
            
            pFlight.selectStatus =FLIGHT_SELECTION_STATUS.selected;
            this.assignObSelFlight(pFlight);
            pFlightObj=this.toRemoveSelectableClass(pFlightObj.ob,pFlight);

          } else if (this.searchObj.trip == TRIP.ROUND_TRIP && this.selFlight) {
           
            if (pFlight) {
              if (pFlightObj.ob) {
               
              pFlightObj=this.isValidFlights(pFlightObj,'obSelected',
                  pFlight);
              
              }

            }
          }
        }
        retValue = pFlightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in onObSelFlight",
          err.toString(),
          "onObSelFlight",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //ib selected flights
    onIbSelFlight(pFlight, pFlightObj) {
 
      let retValue = null;

      try {
        if (BaseConfiguration.isDebug) console.log("onIbSelFlight");

        if (pFlight && this.selFlight) {
          
          
          if (pFlightObj.ib) {
            
              pFlightObj=this.isValidFlights(
             pFlightObj,'ibSelected',
                  pFlight);
           
              }
            
        }
        retValue = pFlightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in onIbSelFlight",
          err.toString(),
          "onIbSelFlight",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


  

    //to remove selectable class
 isValidFlights(pFlightObject,pSelBound,pSelIbObj) {
      let retValue = null;
      let isObChanged=false;
      let isIbChanged=false;
      let canSelect=false;
      try {
        if (BaseConfiguration.isDebug) console.log("isValidFlights");

        
    /// if the flight class which is selected is disabled no process will further happen
    if(pSelIbObj.selectStatus==FLIGHT_SELECTION_STATUS.disable) {
        canSelect=false;
        //  this.showToast(
        //             this.$t("Invalid Flight Selection"),
        //             TOAST_TYPE.ERROR,
        //             1000,
        //             null
        //           );
    }
    else{
      canSelect=true;
    }
              
    /// if the selected flight class is not an disabled one assign for the selected flights        
      if(canSelect==true){
        if(this.relevantOBCount!=0){
          this.relevantOBCount=0;
        }
        if(this.relevantIBCount!=0){
          this.relevantIBCount=0;
        }
         if(this.selFlight.ob && this.selFlight.ib==null) {
          
               pFlightObject.ib=this.toRemoveSelectableClass(pFlightObject.ib,pSelIbObj);
            }
            if(this.selFlight.ib && this.selFlight.ob==null) {
               pFlightObject.ob=this.toRemoveSelectableClass(pFlightObject.ob,pSelIbObj);
            }
         
        if(pSelBound=='obSelected') {
          if(this.selFlight.ob!=null && pSelIbObj.pId!=this.selFlight.ob.pId)
          {
            isObChanged=true;
          }
          else{
            isObChanged=false;
          }
           this.assignObSelFlight(pSelIbObj);
          
          }else{
          if(this.selFlight.ib!=null && pSelIbObj.pId!=this.selFlight.ib.pId)
          {
            isIbChanged=true;
          }
          else {
            isIbChanged=false;
          }
          this.assignIbSelFlight(pSelIbObj);
          
          }
         
         ///to compare the matching id for the selected flights
          if(this.selFlight.ob && this.selFlight.ib) {
            
           ///to clear class when selecting the flights after both flights have selected
            if(isObChanged==true ){
              pFlightObject = this.toChangetheSelFlight(this.selFlight,pSelIbObj,pFlightObject.ob,pFlightObject.ib);
             isIbChanged=false;
           }

           if(isIbChanged==true ){
             pFlightObject = this.toChangetheSelFlight(this.selFlight,pSelIbObj,pFlightObject.ib,pFlightObject.ob);
             isObChanged=false;
           }
            
                } 
                else{
             
              pSelBound=='obSelected'?pFlightObject.ob=
               this.toRemoveSelectableClass(pFlightObject.ob,pSelIbObj):pFlightObject.ib=
               this.toRemoveSelectableClass(pFlightObject.ib,pSelIbObj)
               pSelBound=='obSelected'?  pFlightObject.ib= this.toAddSelectableClass(
              pFlightObject.ib,
              pSelIbObj):  pFlightObject.ob= this.toAddSelectableClass(
              pFlightObject.ob,
              pSelIbObj);
            } 
       
      }

        retValue = pFlightObject;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in isValidFlights",
          err.toString(),
          "isValidFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
 },

///to change the selected flights
 toChangetheSelFlight(pSelFlight,pSelIbObj,pRemoveFlight,pAddFlight,) {
    let retValue;
    let flight;
     try {
       flight = pSelIbObj.obFlight ? pSelFlight.ib :pSelFlight.ob;
       if(BaseConfiguration.isDebug) console.log("toChangetheSelFlight");
       if(pSelFlight.ob.hasOwnProperty('matchingId') && pSelFlight.ib.hasOwnProperty('matchingId'))
             {
             
              if(pSelIbObj.matchingId.length>0){
                if(pSelIbObj.matchingId.includes(flight.pId)){
                  retValue=this.toRemoveSelectableClass(pRemoveFlight,pSelIbObj);
                }else{
                  retValue= this.toAddSelectableClass(pAddFlight, pSelIbObj);
                }
              }

             }
             else if(!pSelIbObj.hasOwnProperty('matchingId') && !flight.hasOwnProperty('matchingId')){
               retValue=this.toRemoveSelectableClass(pRemoveFlight,pSelIbObj);
              //  retValue= this.toAddSelectableClass(pAddFlight, pSelIbObj);
             }
             else if((pSelIbObj.hasOwnProperty('matchingId') && !flight.hasOwnProperty('matchingId')) ||
                    (!pSelIbObj.hasOwnProperty('matchingId') && flight.hasOwnProperty('matchingId'))) {
                retValue= this.toAddSelectableClass(pAddFlight, pSelIbObj);
                retValue=this.toRemoveSelectableClass(pRemoveFlight,pSelIbObj);
                  
             }
 
     } catch (err) {
             let body = Logger.buildRequest(
               FILE_NAME.TOUR_FLIGHT_RESULTS,
               "error in toChangetheSelFlight",
               err.toString(),
               "toChangetheSelFlight",
               LOG_TYPE.ERROR
             );
             Logger.getResponse(body);
           }
       return retValue;
}, 

     /// if isToCheck param is true - to check if the selected flight is in filtered flight list or not
     /// if isToCheck param is false - to remove the selectable class of flight 
    tocheckForSelectedClass(pFlightObj,pSelIbObj,isToCheck) {
      let retValue;
      let noSelectedFlight=false;
        try {
          if(BaseConfiguration.isDebug) console.log("toRemoveSelectableClass");
          
        if (pFlightObj){
          for (var i in pFlightObj) {
            if(noSelectedFlight==false) {
            for (let j = 0; j < pFlightObj[i].length; j++) {
              if(pSelIbObj){
             if(pFlightObj[i][j].pId && pSelIbObj.pId){
               if(isToCheck) {
              if (pFlightObj[i][j].pId != pSelIbObj.pId) {
                  noSelectedFlight=false;
                  retValue=noSelectedFlight;
              }
              else{
                // pFlightObj[i][j].selectStatus = FLIGHT_SELECTION_STATUS.selected;
                noSelectedFlight=true;
                retValue=noSelectedFlight;
                break;
              }
              
               }
               else{
                 if (pFlightObj[i][j].pId == pSelIbObj.pId) {
                 pFlightObj[i][j].selectStatus = FLIGHT_SELECTION_STATUS.noClass;
              }
              retValue=pFlightObj;
               }
             }
            }
          }
          }
          }
        }
          
     
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in toRemoveSelectableClass",
                  err.toString(),
                  "toRemoveSelectableClass",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
},    

    /// to remove the selectable class
    toRemoveSelectableClass(pFlightObj,pSelIbObj) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toRemoveSelectableClass");
          if(!pFlightObj) {
            if(pSelIbObj.obFlight){
              pFlightObj=this.bindedFlightLs.ob;
              if(this.selFlight.ib==null) {
              pFlightObj=this.toAddSelectableClass(this.bindedFlightLs.ib,null);
              }
              pSelIbObj=null;
            }else if(pSelIbObj.ibFlight){
               pFlightObj=this.bindedFlightLs.ib;
               if(this.selFlight.ob==null) {
              pFlightObj=this.toAddSelectableClass(this.bindedFlightLs.ob,null);
              }
               
               pSelIbObj=null;
            }
          }
        if (pFlightObj){
          for (var i in pFlightObj) {
            for (let j = 0; j < pFlightObj[i].length; j++) {
              if(pSelIbObj){
             if(pFlightObj[i][j].pId && pSelIbObj.pId){
              if (pFlightObj[i][j].pId != pSelIbObj.pId) {
                  pFlightObj[i][j].selectStatus = FLIGHT_SELECTION_STATUS.noClass;
              }
              else{
                pFlightObj[i][j].selectStatus = FLIGHT_SELECTION_STATUS.selected;
                
              }
             }
            }else{
              pFlightObj[i][j].selectStatus = FLIGHT_SELECTION_STATUS.noClass;
            }
          }
          }
        }
          
     retValue=pFlightObj;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in toRemoveSelectableClass",
                  err.toString(),
                  "toRemoveSelectableClass",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

    //to add selectable class
    toAddSelectableClass(pFlightObj, pselFlight) {
     
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("toAddSelectableClass");
        for (var i in pFlightObj) {
          for (let j = 0; j < pFlightObj[i].length; j++) {
            if(pFlightObj[i][j].selectStatus==FLIGHT_SELECTION_STATUS.selectable ||
            pFlightObj[i][j].selectStatus==FLIGHT_SELECTION_STATUS.disable)
              {
                pFlightObj[i][j].selectStatus=FLIGHT_SELECTION_STATUS.noClass;
              }
            if (pselFlight && pFlightObj[i][j]) {
              pFlightObj[i][j] = this.getRelevantFlight(
                pFlightObj[i][j],
                pselFlight
              );
            }
          }
        }
        retValue = pFlightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in toAddSelectableClass",
          err.toString(),
          "toAddSelectableClass",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

    //get relevant flightsbased on matching id
    getRelevantFlight(pFlightObj, pselFlightDept) {
      
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRelevantFlight");
        if(pselFlightDept.obFlight){
                     this.assignIbSelFlight();
                     if(this.selFlight.ib==null){
           this.scrollToElement('scrollToReturn')
         }
                   }else if(pselFlightDept.ibFlight){
                     this.assignObSelFlight();
                     if(this.selFlight.ob==null){
           this.scrollToElement('scrollToDeparture')
         }
                   }
                   if(pselFlightDept) {
        if (pselFlightDept.matchingId ) {
              if( pFlightObj.hasOwnProperty('matchingId')){

              
                for (let index = 0; index < pselFlightDept.matchingId.length; index++) {
              if(pFlightObj.selectStatus!=FLIGHT_SELECTION_STATUS.selectable){
                 if(pFlightObj.pId==pselFlightDept.matchingId[index]) {

              
                pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.selectable;
                
                if(pFlightObj.ibFlight) {
                  this.relevantIBCount+=1;
                }
                else if(pFlightObj.obFlight) {
                  
                    this.relevantOBCount+=1;
                    
                }
               }
                  
                 else {
                   
                pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.disable;
              }
            }
                }
             
              
              }
              else{
                pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.disable;
              }
        }
        else if(!pselFlightDept.hasOwnProperty('matchingId')){

        
          if (!pFlightObj.hasOwnProperty('matchingId'))
          {
            
          
          pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.selectable;
          
          if(pFlightObj.ibFlight) {
                 this.relevantIBCount+=1;
                }
                else if(pFlightObj.obFlight) {
                  
                    this.relevantOBCount+=1;
                   
                }
        }
        else{
          pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.disable;
        }
        }
      }
      else{
        pFlightObj.selectStatus = FLIGHT_SELECTION_STATUS.noClass;
      }
        
        retValue = pFlightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in getRelevantFlight",
          err.toString(),
          "getRelevantFlight",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

 //to get class for airline card
    getClassforALCard(pFlightObj) {
      let retValue = false;
      try {
        
        if (!retValue && pFlightObj) {
          for (let i = 0; i < pFlightObj.length; i++) {
           if(pFlightObj[i].selectStatus==FLIGHT_SELECTION_STATUS.selected){
            retValue=true;
            break;
          }
          else{
            retValue=false;
            
           }
           }
           } 
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in getClassforALCard",
                  err.toString(),
                  "getClassforALCard",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

 

    //sorted list emit from cSortDropDown  based on property value
    getObSortedVal(pselObSortVal) {
      try {
        this.selObSortVal = pselObSortVal;
        
        this.SET_OB_SEL_SORT_OBJ(this.selObSortVal);
        
       
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error while emitting from CSortDropDown",
          err.toString(),
          "getObSortedVal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
},


    //sorted list emit from cIbSortDropDown  based on property value
    getIbSortedVal(pselIbSortVal) {
      try {
        
        this.selIbSortVal = pselIbSortVal;
        this.SET_IB_SEL_SORT_OBJ(this.selIbSortVal);
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error while emitting from CSortDropDown",
          err.toString(),
          "getSortedList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
},

    //to show or hide search component
    isToggleCSearch() {
      try {
        if (BaseConfiguration.isDebug) console.log("isToggleCSearch");

        this.isModifySearch = !this.isModifySearch;
      
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error while modifing search",
          err.toString(),
          "isToggleCSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
},

    ///to get list of search results from api
    async getSearchResponse(pSearchObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getSearchResponse");

        let getSearchRequest = apiSearchResult.buildRequest(pSearchObj);

        if (getSearchRequest) {
          // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
          let getSearchResponse = await apiSearchResult.getResponse(
            getSearchRequest
          );



          if (VALIDATE_SUCCESS_RES(getSearchResponse)) {
            this.isLoading=false;
            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store
            this.SET_SEARCH_RES(getSearchResponse.data.data);
            retValue = getSearchResponse.data.data;
            
          } else {
            let error = getErrorMessage(getSearchResponse);
            let isSessionExpired;
            if(getSearchResponse) {
              isSessionExpired= handleSessionExist(getSearchResponse.data);
            }
          
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }

          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in getting response from get search result response API",
          err.toString(),
          "getSearchResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

    //nav to pax info page
    goToPaxInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("goToPaxInfo");
        // this.CLEAR_PAX_STORE();
       if(this.$router.currentRoute.path==PATHNAME.TOUR_FLIGHT_RESULTS){
        navigate(PATHNAME.PAXPAGE,this.$router.currentRoute.query);

       }
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in goToPaxInfo",
          err.toString(),
          "goToPaxInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
},

    //to disable continue button
    toDisableContinueButton() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toDisableContinueButton");
        if (this.searchObj && this.searchObj.trip == TRIP.ROUND_TRIP) {
          if (
            this.selFlight &&
            this.selFlight.ob != null &&
            this.selFlight.ib != null
          ) {
            retValue = false;
          } else {
            retValue = true;
           
          }
        } else if (this.selFlight && this.searchObj && this.searchObj.trip == TRIP.ONE_WAY) {
          if (this.selFlight.ob != null) {
            retValue = false;
          } else {
            retValue = true;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in toDisableContinueButton",
          err.toString(),
          "toDisableContinueButton",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},


    ///check availability of flights based on trip
    checkFlightsforTrip(pSearchObj,pSearchResult) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("checkFlightsforTrip");
           if(pSearchObj.trip == TRIP.ONE_WAY){
            if(pSearchResult && pSearchResult.flight_results && pSearchResult.flight_results.obflights && pSearchResult.flight_results.obflights.length>0) 
            {               
               retValue=false;               
            }
            else{
              retValue=true;
            }
           }else if(pSearchObj.trip == TRIP.ROUND_TRIP) {
             if( pSearchResult && pSearchResult.flight_results && pSearchResult.flight_results.obflights && pSearchResult.flight_results.obflights.length>0 
             &&  pSearchResult.flight_results.ibflights && pSearchResult.flight_results.ibflights.length>0) 
                {
                  retValue=false;
                }
              else{
                retValue=true;
              }
           }
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in checkFlightsforTrip",
                  err.toString(),
                  "checkFlightsforTrip",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

    //Adding selectStatus, pricegroup_code, Via_Obj, TotalDuration, no_of_days, no_of_stops, no_of_ViaObj
    assigningFlightProp(pFlight,isOb) {
       let flightObj;
        try {
       
          if(BaseConfiguration.isDebug) console.log("assigningFlightProp");
          // if(isOb){
          //   pFlight.obFlight[0].flight.via={text: "Via London, Singapore"}
          //   pFlight.obFlight[1].flight.via={text: "Via Dubai"}
      
          // }else{
          //   pFlight.ibFlight[0].flight.via={text: "Via London"}
          // }
          flightObj = isOb? pFlight.obFlight : pFlight.ibFlight;
           pFlight["selectStatus"] = FLIGHT_SELECTION_STATUS.noClass;
           pFlight["isMaxFare"]=false;
           let depdate = this.$options.filters.formatDate(
            flightObj[0].flight.DepDate,"DDMMMYYYYHHMM");
            
          pFlight["pricegroup_code"] = 
            
            flightObj[0].flight.FlightNo +
            flightObj[0].flight.opAirline +
            flightObj[0].flight.DepAirport +
            depdate;
            pFlight.pricegroup_code=pFlight.pricegroup_code.toUpperCase().replace('-','');
        //  flightObj[0].flight["Via_Obj"] = flightObj[0].flight.via !=null && 
        //                                               flightObj[0].flight.via.text && 
        //                                               flightObj[0].flight.via.text!=null?
        //                                             flightObj[0].flight.via.text:
        //                                             this.$t('flightResults.nonstop');
        // pFlight.pricegroup_code = pFlight.pId;
        flightObj[0].flight["Via_Obj"] = '';
          flightObj[0].flight["TotalDuration"] = 1;
          flightObj[0].flight["no_of_days"] = 0;
          flightObj[0].flight["no_of_stops"] = {
            code:0,
            name:null,
            status:0,
            by:'default'
          };
          flightObj[0].flight["no_of_viaObj"] = {
            code:0,
            name:null,
            status:1,
            by:'default'
          };


      

          flightObj[0].flight.no_of_stops.name =
              flightObj.length-1 == 0 ? this.$t('flightResults.nonstop') : flightObj.length-1 == 1
                ? flightObj.length-1 + ' '+this.$t('flightResults.stop')
                : flightObj.length-1 > 1 ? flightObj.length-1 + ' '+this.$t('flightResults.stops') :null;
         flightObj[0].flight.no_of_stops.code =
              flightObj.length;

          this.obStops.push(flightObj[0].flight.no_of_stops);
          this.ibStops.push(flightObj[0].flight.no_of_stops);


            // flightObj[0].flight.no_of_days =
            //   getDiffBtwDates(
            //     new Date(flightObj[flightObj.length - 1].flight.ArrDate),
            //     new Date(flightObj[0].flight.DepDate),
                
            //     "days"
            //   ) != 0
            //     ? "+" +
            //       getDiffBtwDates(
            //         new Date(flightObj[flightObj.length - 1].flight.ArrDate),
            //         new Date(flightObj[0].flight.DepDate),
                    
            //         "days"
            //       )
            //     : null;
                 flightObj[0].flight.no_of_days =
              differnceofDates(
               flightObj[flightObj.length - 1].flight.ArrDate,
                flightObj[0].flight.DepDate
              ) != 0
                ? "+" +
                  differnceofDates(
                    flightObj[flightObj.length - 1].flight.ArrDate,
                    flightObj[0].flight.DepDate
                  )
                : null;
          for (let j = 0; j <flightObj.length; j++) {
            
            
            flightObj[0].flight.TotalDuration +=
              flightObj[j].flight.DurationInMin;
            if (flightObj[j].transit.transittime!="") {
              flightObj[0].flight.TotalDuration +=
                flightObj[j].transit.transittime;
            }
            
            if(flightObj[j].flight.via && flightObj[j].flight.via!=null  &&   flightObj[j].flight.via.text && 
              flightObj[j].flight.via.text!=null) {
                if(j==0){
                  flightObj[0].flight.Via_Obj+=flightObj[j].flight.via.text;
                }else{
            flightObj[0].flight.Via_Obj+="," + flightObj[j].flight.via.text.replace('Via',"");
                }
              }
          }
          if(flightObj[0].flight.Via_Obj==null || flightObj[0].flight.Via_Obj==""){
            flightObj[0].flight.Via_Obj=this.$t('flightResults.nonstop');
          }
         
        if(flightObj.length==1) {
          if(flightObj[0].flight.Via_Obj!='Non-Stop') {
            flightObj[0].flight.no_of_viaObj.code=flightObj[0].flight.Via_Obj.split(',').length+1;
            flightObj[0].flight.no_of_viaObj.name=flightObj[0].flight.Via_Obj.split(',').length+' '+'Stop';
            flightObj[0].flight.no_of_viaObj.status=0;
            flightObj[0].flight.no_of_viaObj.by='default';
       
          }
          else{
           flightObj[0].flight.no_of_viaObj.code=flightObj[0].flight.Via_Obj.split(',').length;
            flightObj[0].flight.no_of_viaObj.name='Non-Stop';
            flightObj[0].flight.no_of_viaObj.status=0;
            flightObj[0].flight.no_of_viaObj.by='default';
        
          }
        }
        else if(flightObj.length>1){
          flightObj[0].flight.no_of_viaObj = flightObj[0].flight.no_of_stops;
        }
         
      
          if(isOb)
            pFlight.obFlight = flightObj;
          else
            pFlight.ibFlight = flightObj;

          
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assigningFlightProp",
                  err.toString(),
                  "assigningFlightProp",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return pFlight;
 }, 
    
    ///to get the binded list of flights from original response
    getCombinedList(res) {
      let retValue = {
        ob: null,
        ib: null
      };
      let flightTofilterList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getCombinedList");
        if(!res){
          res = this.GET_SEARCH_RES;
        }
        if(res.flight_results.obflights && res.flight_results.obflights.length!=0) {
         
        let obLIst = res.flight_results.obflights;
        
        for (let index = 0; index < obLIst.length; index++) {
        const flightsObj = obLIst[index];
        var viaObLs=[];
        flightsObj=this.assigningFlightProp(flightsObj , true);
        flightTofilterList.push(flightsObj);
       
        }
        retValue.ob = groupBy(flightTofilterList, "pricegroup_code");
      }
        if(res.flight_results.ibflights && res.flight_results.ibflights.length!=0) {
        let ibLIst = res.flight_results.ibflights;
        flightTofilterList = [];
        for (let index = 0; index < ibLIst.length; index++) {
        const flightsObj = ibLIst[index];
        var viaIbLs=[];
        flightsObj=this.assigningFlightProp(flightsObj, false); 
        flightTofilterList.push(flightsObj);
       
        }
        retValue.ib = groupBy(flightTofilterList, "pricegroup_code");
        }
       
        retValue= JSON.parse(JSON.stringify(retValue));
        var orgBindedLs= cloneData(retValue);
        this.SET_ORG_BINDED_FLIGHT_LS(orgBindedLs);
         if(this.searchStoreObj!=null && this.searchStoreObj.trip == TRIP.ROUND_TRIP && res.flight_results.obflights.length!=0 && res.flight_results.ibflights.length!=0) {
        this.SET_BINDED_FLIGHT_LS(orgBindedLs);
         } else if(this.searchStoreObj!=null && this.searchStoreObj.trip == TRIP.ONE_WAY && res.flight_results.obflights.length!=0){
           this.SET_BINDED_FLIGHT_LS(orgBindedLs);
         }
        this.assignBindedFlights(retValue) ;  
       

        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in getCombinedList",
          err.toString(),
          "getCombinedList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignBindedFlights(pBindedFlights) {
      
        try {
          if(BaseConfiguration.isDebug) console.log("assignBindedFlights");
          this.bindedFlightLs.ob = pBindedFlights.ob;
          this.bindedFlightLs.ib = pBindedFlights.ib;
         
          
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignBindedFlights",
                  err.toString(),
                  "assignBindedFlights",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
  }, 



    /// search functionality on modify search
    async onSearch(pSearchObj) {
      // let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("onSearch");
        // this.SET_IS_MODIFY_SEARCH(true);
       if(pSearchObj.trip == 3) {
         this.CLEAR_ML_RESULT_STORE();
          navigate(PATHNAME.ML_FLIGHTRESULTS);
        }
        else{
        this.isModifySearch=false;
        this.bindedFlightLs.ob=null;
        this.bindedFlightLs.ib=null;
        this.filterObWatchList = null;
        this.filterIbWatchList = null;
        this.isLoading=true;
        this.assignObSelFlight();
        this.assignIbSelFlight();
        this.cheapestLs=[];
        this.CLEAR_RESULT_STORE();
        this.SET_SEARCH_OBJ(pSearchObj);
        this.formattingFlightRes();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in modifySearch",
          err.toString(),
          "searching",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
     
    },

    /// to get selected filter from store
    getSelectedVal(pbindedFlights) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedVal");

        if(this.GET_OB_SEL_SORT_VALUE!=null){
          this.selObSortVal = this.GET_OB_SEL_SORT_VALUE;
        }
        else{
          this.selObSortVal = null;
        }

        if(this.GET_IB_SEL_SORT_VALUE!=null){
          this.selIbSortVal = this.GET_IB_SEL_SORT_VALUE;
        }
        else{
          this.selIbSortVal = null;
        }
          if(!this.sSelObFlightObj ){
           this.assignObSelFlight(); 
          }
         
          else{
            if(this.sSelObFlightObj  && pbindedFlights.ob ) { 
              var seObFlight= cloneData(this.sSelObFlightObj);
             this.assignObSelFlight(seObFlight);
             this.toRemoveSelectableClass(pbindedFlights.ob,seObFlight);
             this.getClassforALCard(pbindedFlights.ob);
            }
          }
            if(!this.sSelIbFlightObj ){
              this.assignIbSelFlight();
          }
         
          else{
            if(this.sSelIbFlightObj &&  pbindedFlights.ib) { 
              var seIbFlight= cloneData(this.sSelIbFlightObj);
             this.assignIbSelFlight(seIbFlight); 
             this.toRemoveSelectableClass(pbindedFlights.ib,seIbFlight);
             this.getClassforALCard(pbindedFlights.ib);
            }
          }

          if(this.GET_OB_FILTER_DATA && this.GET_OB_FILTER_DATA.al && this.GET_OB_FILTER_DATA.al.length!=0) {
            this.filterObWatchList=this.GET_OB_FILTER_DATA;
      
          }
          else if(this.GET_AIRLINES!=null){
            
             this.filterObWatchList= pbindedFlights.ob!=null? 
                                     this.assignObFilterVal(pbindedFlights.ob,true,this.GET_AIRLINES):null;
               var ObfilterLs= cloneData(this.filterObWatchList);
               this.SET_OB_FILTER_DATA(ObfilterLs);
          }
          if(this.GET_IB_FILTER_DATA &&this.GET_IB_FILTER_DATA.al && this.GET_IB_FILTER_DATA.al.length!=0 ) {
            this.filterIbWatchList=this.GET_IB_FILTER_DATA;
          }
          else if(pbindedFlights.ib!=null && this.GET_AIRLINES!=null){
            this.filterIbWatchList=pbindedFlights.ib!=null? 
                                    this.assignIbFilterVal(pbindedFlights.ib,true,this.GET_AIRLINES):null;
              
             
              var IbfilterLs= cloneData(this.filterIbWatchList);
              
              this.SET_IB_FILTER_DATA(IbfilterLs);
          }
          if(this.GET_OB_DISP_FILTER_LS && this.GET_OB_DISP_FILTER_LS.length!=0){
            this.obFilterTag=this.GET_OB_DISP_FILTER_LS;
          }else{
            this.obFilterTag=[];
          }

          if(this.GET_IB_DISP_FILTER_LS && this.GET_IB_DISP_FILTER_LS.length!=0){
            this.ibFilterTag=this.GET_IB_DISP_FILTER_LS;
          }else{
            this.ibFilterTag=[];
          }

          if(this.GET_CHEAPEST_LS!=null){
            this.cheapestLs=this.GET_CHEAPEST_LS;
          }else{
            this.cheapestLs=[];
          }
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in getSelectedVal",
          err.toString(),
          "getSelectedVal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    updateRouteUrl(pSessionId) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateRouteUrl");

        if (pSessionId) {
          let param = {};
          param[ROUTER_PARAM.SESSION_ID] = pSessionId;
     
            updateCurrRouteQuery(param)
         
        }else{
          throw "invlaid session id"
        }
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.TOUR_FLIGHT_RESULTS,
          "error in updateRouteUrl",
          err.toString(),
          "updateRouteUrl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    

    



    ///functionality to show toast
    showToastForFlights(pBindedFlightLs, pSearchObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("showToastForFlights");
         
             this.showToast(null, TOAST_TYPE.CLEAR);
          let toastAction = {
            text: this.$t('flightResults.modifySearch'),
            onClick: () => {
              this.isModifySearch = true;
              scrollToTop();
            }
          };
          if (pBindedFlightLs) {
            if (pSearchObj && pSearchObj.trip == TRIP.ONE_WAY && pBindedFlightLs.ob) {
              this.showToast(
                Object.keys(pBindedFlightLs.ob).length +
                  this.$t('flightResults.flightsAvailable'),
                TOAST_TYPE.SUCCESS,
                1000,
                null
              );
            } else if(pSearchObj && pSearchObj.trip == TRIP.ROUND_TRIP && pBindedFlightLs.ob && pBindedFlightLs.ib) {
              this.showToast(
                Object.keys(pBindedFlightLs.ob).length +
                  Object.keys(pBindedFlightLs.ib).length +
                  this.$t('flightResults.flightsAvailable'),
                TOAST_TYPE.SUCCESS,
                1000,
                null
              );
            }
            else if(!(pSearchObj && pSearchObj.trip == TRIP.ROUND_TRIP?pBindedFlightLs.ob && pBindedFlightLs.ib:pBindedFlightLs.ob)){
            this.showToast(
              this.$t('flightResults.noFlights'),
              TOAST_TYPE.ERROR,
             2000,
              toastAction
            );
          } 
            // this.showToast(null, TOAST_TYPE.CLEAR);
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in showToastForFlights",
                  err.toString(),
                  "showToastForFlights",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
    }, 

    /// handling the response when the page is created
    async formattingFlightRes() {
      let retSearchResult = null;
      try {
        if (BaseConfiguration.isDebug) console.log("formattingFlightRes");
       let bindedFlights;
      // console.log('SEARCH'+this.searchStoreObj);
        if (this.searchStoreObj != null) {
          this.searchObj = cloneDeep(this.searchStoreObj);
          // console.log(this.searchObj);
          this.showToast("", TOAST_TYPE.CLEAR, null, null);

          
          if(this.sStoreBindedLs==null) {
          this.showToast(this.$t('flightResults.searching'), TOAST_TYPE.INFO, null, null);
           retSearchResult = await this.getSearchResponse(this.searchObj);
         
         
            if(retSearchResult&&retSearchResult.sessionId) {
            this.updateRouteUrl(retSearchResult.sessionId);
                          // this.SET_IS_MODIFY_SEARCH(false);

            }
            if(retSearchResult){
            this.SET_AIRLINES(retSearchResult.airlines);
            this.SET_AIRPORTS(retSearchResult.airports);
          this.SET_CURRENCY(retSearchResult.currency);
            bindedFlights= this.getCombinedList(retSearchResult);
            }
            this.showAlert = this.checkFlightsforTrip(this.searchObj,retSearchResult); 
            if(this.showAlert==false) { 
                this.cheapestLs = this.getCheapestFile(retSearchResult.flight_results);
                this.SET_CHEAPESTLS(this.cheapestLs);
            }
             this.showToastForFlights(bindedFlights,this.searchObj);
          }
          else{
            bindedFlights=this.sStoreBindedLs;
            this.isLoading=false;
          }
        
          
          
        /// to get the selected filter value from store
        if(bindedFlights!=null) {
          
        this.getSelectedVal(bindedFlights);
        }
            
         
          
       
        } //invalid search obj
        else {
          this.searchObj = null;
          navigate(PATHNAME.FLIGHTSEARCH);
        }//need to handle
        
        
        if (BaseConfiguration.isDebug)console.log(bindedFlights);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TOUR_FLIGHT_RESULTS,
          "error in formattingFlightRes",
          err.toString(),
          "formattingFlightRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


 assignObFilterVal(pBindedFlightLs, isOb, pAirlines) {
    let retValue={
      
        al: [],
        stops:[],
        via:[],
        price:{
          min: null,
          max: null,
          from:0,
          to:0,
         priceLs:[],
          by:'default'
        },
        depTime:[],
        arrTime:{
          start: null,
          end: null,
          
        },
        totalDuration:{
          start: null,
          end:null,
          from:0,
          to:0,
           by:'default'
        }
    }
   try {
          if(BaseConfiguration.isDebug) console.log("assignObFilterVal");
            let obList=[];
        let obPriceList=[];
        for (var i in pBindedFlightLs) {
          if(pBindedFlightLs[i].length!=0){
            obList.push(pBindedFlightLs[i]);
           retValue.via.push(pBindedFlightLs[i][0].obFlight[0].flight.no_of_viaObj);
           retValue.stops.push(pBindedFlightLs[i][0].obFlight[0].flight.no_of_stops);
            for (let j=0; j<pBindedFlightLs[i].length;j++) {
              obPriceList.push(pBindedFlightLs[i][j]);
            } 
          }     
        }
         for (var index in pAirlines) {
          let airline={
          name: pAirlines[index].airline_name,
          code: index,
          status: 0,
          by:'default'
          }
        retValue.al.push(airline);
       
       }
      
       var no_of_stops = {
             code:0,
            name:this.$t('flightResults.allStops'),
            status:1,
            by:'default'
          };
       retValue.stops.push(no_of_stops);
      //  if(retValue.stops.length==0) {
        retValue.stops=[...new Map(retValue.stops.map(item => [item['code'], item])).values()];
        retValue.stops.sort((a, b) => (a.code > b.code) ? 1 : -1)
      //  }
       let obSortDepTime = _.sortBy(obList, e => e[0].obFlight[0].flight.DepDate);
     
       let obPUnitSortedArray = _.sortBy(obPriceList, e => e.clientPricing.AdultPrice.Total);
       let obDurationSortedArray= _.sortBy(obList, e => e[0].obFlight[0].flight.TotalDuration);

      
         ///priceLs
            if(obPUnitSortedArray && obPUnitSortedArray.length!=0){  
      for (let i = 0; i < obPUnitSortedArray.length; i++) {
         retValue.price.priceLs.push(obPUnitSortedArray[i].clientPricing.AdultPrice.Total);
      }
         
       }
       ///time
       retValue.depTime=[
       {
         start: "06:00",
         end: "11:59",
         status:0,
         by:'default'
       },
       {
         start: "12:00",
         end: "17:59",
          status:0,
         by:'default'
       },
       {
         start: "18:00",
         end: "23:59",
          status:0,
         by:'default'
       },
       {
         start: "00:00",
         end: "05:59",
          status:0,
         by:'default'
       }
       ]
      
        ///price
          retValue.price.min=retValue.price.priceLs[0];
          retValue.price.max=retValue.price.priceLs[retValue.price.priceLs.length-1];
          retValue.price.from=retValue.price.priceLs[0];
          retValue.price.to=retValue.price.priceLs[retValue.price.priceLs.length-1];
       
          ///duration
       retValue.totalDuration.start=obDurationSortedArray[0][0].obFlight[0].flight.TotalDuration;
       retValue.totalDuration.end=obDurationSortedArray[obDurationSortedArray.length-1][0].obFlight[0].flight.TotalDuration;
       retValue.totalDuration.from=obDurationSortedArray[0][0].obFlight[0].flight.TotalDuration;
       retValue.totalDuration.to=obDurationSortedArray[obDurationSortedArray.length-1][0].obFlight[0].flight.TotalDuration;

        var noOfviaObj = {
             code:0,
            name:this.$t('flightResults.allStops'),
            status:1,
            by:'default'
          };
       retValue.via.push(noOfviaObj);
       retValue.via=[...new Map(retValue.via.map(item => [item['code'], item])).values()];
       retValue.via.sort((a, b) => (a.code > b.code) ? 1 : -1);
       
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignObFilterVal",
                  err.toString(),
                  "assignObFilterVal",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

assignIbFilterVal(pBindedFlightLs, isOb, pAirlines) {
    let retValue={
     
        al: [],
        stops:[],
        via:[],
        price:{
         min: null,
          max: null,
          from:0,
          to:0,
          priceLs:[],
           by:'default'
        },
        depTime:[],
        totalDuration:{
          start: null,
          end:null,
          from:0,
          to:0,
           by:'default'
        }
   
    };
        try {
          if(BaseConfiguration.isDebug) console.log("assignIbFilterVal");
            let obList=[];
        let obPriceList=[];
        for (var i in pBindedFlightLs) {
          if(pBindedFlightLs[i].length!=0){
            obList.push(pBindedFlightLs[i]);
             retValue.via.push(pBindedFlightLs[i][0].ibFlight[0].flight.no_of_viaObj);
             retValue.stops.push(pBindedFlightLs[i][0].ibFlight[0].flight.no_of_stops);
            for (let j=0; j<pBindedFlightLs[i].length;j++) {
              obPriceList.push(pBindedFlightLs[i][j]);
            } 
          }     
        }
         for (var index in pAirlines) {
          let airline={
          name: pAirlines[index].airline_name,
          code: index,
          status: 1,
          by:'default'
          }
      
        retValue.al.push(airline);
       }
      
      //   if( retValue.stops.length==0) {
      //   retValue.stops=[...new Map(this.ibStops.map(item => [item['code'], item])).values()];
      //  retValue.stops.sort((a, b) => (a.code > b.code) ? 1 : -1)
      //  }

        var no_of_stops = {
             code:0,
            name:this.$t('flightResults.allStops'),
            status:1,
            by:'default'
          };
       retValue.stops.push(no_of_stops);
      //  if(retValue.stops.length==0) {
        retValue.stops=[...new Map(retValue.stops.map(item => [item['code'], item])).values()];
        retValue.stops.sort((a, b) => (a.code > b.code) ? 1 : -1)
      //  }
       
      
       let ibSortDepTime = _.sortBy(obList, e => e[0].ibFlight[0].flight.DepDate);
     
       let ibPUnitSortedArray = _.sortBy(obPriceList, e => e.clientPricing.AdultPrice.Total);
       let ibDurationSortedArray= _.sortBy(obList, e => e[0].ibFlight[0].flight.TotalDuration);

         ///priceLs
     if(ibPUnitSortedArray && ibPUnitSortedArray.length!=0){  
      for (let i = 0; i < ibPUnitSortedArray.length; i++) {
         retValue.price.priceLs.push(ibPUnitSortedArray[i].clientPricing.AdultPrice.Total);
      }
         
       }

       ///time
        retValue.depTime=[
       {
         start: "06:00",
         end: "11:59",
         status:0,
         by:'default'
       },
       {
         start: "12:00",
         end: "17:59",
          status:0,
         by:'default'
       },
       {
         start: "18:00",
         end: "23:59",
          status:0,
         by:'default'
       },
       {
         start: "00:00",
         end: "05:59",
          status:0,
         by:'default'
       }
       ]
      
        ///price
          retValue.price.min=retValue.price.priceLs[0];
          retValue.price.max=retValue.price.priceLs[retValue.price.priceLs.length-1];
          retValue.price.from=retValue.price.priceLs[0];
          retValue.price.to=retValue.price.priceLs[retValue.price.priceLs.length-1];
        
          ///duration
       retValue.totalDuration.start=ibDurationSortedArray[0][0].ibFlight[0].flight.TotalDuration;
       retValue.totalDuration.end=ibDurationSortedArray[ibDurationSortedArray.length-1][0].ibFlight[0].flight.TotalDuration;
       retValue.totalDuration.from=ibDurationSortedArray[0][0].ibFlight[0].flight.TotalDuration;
       retValue.totalDuration.to=ibDurationSortedArray[ibDurationSortedArray.length-1][0].ibFlight[0].flight.TotalDuration;

        var noOfviaObj = {
             code:0,
            name:this.$t('flightResults.allStops'),
            status:1,
            by:'default'
          };
       retValue.via.push(noOfviaObj);
       retValue.via=[...new Map(retValue.via.map(item => [item['code'], item])).values()];
       retValue.via.sort((a, b) => (a.code > b.code) ? 1 : -1);

        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignIbFilterVal",
                  err.toString(),
                  "assignIbFilterVal",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
}, 

assignFilterObj(pBindedFlightLs,pAirlines, isObFilter) {
    let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("assignFilterObj");
          
           let obList=[];
        let obPriceList=[];
        for (var i in pBindedFlightLs) {
          if(pBindedFlightLs[i].length!=0){
            obList.push(pBindedFlightLs[i]);
            for (let j=0; j<pBindedFlightLs[i].length;j++) {
              obPriceList.push(pBindedFlightLs[i][j]);
            } 
          }     
        }
       
      retValue=this.getFilterData(obList, obPriceList, isObFilter);
    
          
  
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in assignFilterObj",
                  err.toString(),
                  "assignFilterObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        return retValue;
}, 

 

getFilterData(obList, obPriceList, isOb) {
   let pFilterWatch = {
        al: [],
        stops:[],
        price:{
          min: null,
          max: null,
          from:0,
          to:0,
         priceLs:[],
          by:null
        },
        depTime:[],
        totalDuration:{
          start: null,
          end:null
        }
   
   };
      let pOrgFilterLs = isOb ? this.GET_OB_FILTER_DATA?this.GET_OB_FILTER_DATA:this.filterObWatchList
                        :this.GET_IB_FILTER_DATA?this.GET_IB_FILTER_DATA:this.filterIbWatchList;

        try {
          if(BaseConfiguration.isDebug) console.log("getFilterData");
          
          let ALCode=[];
          let Stops=[];
         let Via=[];
         
           let SortDepTime;
            let SortArrTime;
            let PUnitSortedArray;
            let DurationSortedArray;
            let priceLs=[];
            let depTime=[];
            let timeRange=[
       {
         start: "06:00",
         end: "11:59",
         status:0,
         by:'default'
       },
       {
         start: "12:00",
         end: "17:59",
          status:0,
         by:'default'
       },
       {
         start: "18:00",
         end: "23:59",
          status:0,
         by:'default'
       },
       {
         start: "00:00",
         end: "05:59",
          status:0,
         by:'default'
       }
       ]
          for (let index = 0; index < obList.length; index++) {
           if(obList[index].length!=0 && index < obList.length) {
             if(obList[index][0].obFlight && index < obList.length) {
            ALCode.push(obList[index][0].obFlight[0].flight.opAirline);
            Stops.push(obList[index][0].obFlight[0].flight.no_of_stops);
            Via.push(obList[index][0].obFlight[0].flight.no_of_viaObj);
             
             }
             else if(obList[index][0].ibFlight && index < obList.length){
               ALCode.push(obList[index][0].ibFlight[0].flight.opAirline);
            Stops.push(obList[index][0].ibFlight[0].flight.no_of_stops);
            Via.push(obList[index][0].ibFlight[0].flight.no_of_viaObj);
                    
             }
           }
          }
    
       Via=[...new Map(Via.map(item => [item['code'], item])).values()];
       Via.sort((a, b) => (a.code > b.code) ? 1 : -1);

       Stops=[...new Map(Stops.map(item => [item['code'], item])).values()];
       Stops.sort((a, b) => (a.code > b.code) ? 1 : -1);
          let airlineCode=([...new Set(ALCode)]);


          if(obList.length!=0 && obList[0][0].obFlight) {
       SortDepTime = _.sortBy(obList, e => e[0].obFlight[0].flight.DepDate);
       PUnitSortedArray = _.sortBy(obPriceList, e => e.clientPricing.AdultPrice.Total);
        DurationSortedArray= _.sortBy(obList, e => e[0].obFlight[0].flight.TotalDuration);
          if(SortDepTime && SortDepTime.length!=0){ 
           for (let i = 0; i < timeRange.length; i++) {
      for (let j = 0; j < SortDepTime.length; j++) {
        if(timeRange[i].start<=formatDate(SortDepTime[j][0].obFlight[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) && 
            timeRange[i].end>=formatDate(SortDepTime[j][0].obFlight[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)) {
              depTime.push(timeRange[i]);}}
          }}
          }
          else if(obList.length!=0 && obList[0][0].ibFlight) {
             SortDepTime = _.sortBy(obList, e => e[0].ibFlight[0].flight.DepDate);
       PUnitSortedArray = _.sortBy(obPriceList, e => e.clientPricing.AdultPrice.Total);
       DurationSortedArray= _.sortBy(obList, e => e[0].ibFlight[0].flight.TotalDuration);
        if(SortDepTime && SortDepTime.length!=0){ 
           for (let i = 0; i < timeRange.length; i++) {
      for (let j = 0; j < SortDepTime.length; j++) {
        if(timeRange[i].start<=formatDate(SortDepTime[j][0].ibFlight[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) && 
            timeRange[i].end>=formatDate(SortDepTime[j][0].ibFlight[0].flight.DepDate,DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)) {
              depTime.push(timeRange[i]);}}
          }}
          }
          
          if(PUnitSortedArray && PUnitSortedArray.length!=0){  
      for (let i = 0; i < PUnitSortedArray.length; i++) {
         priceLs.push(PUnitSortedArray[i].clientPricing.AdultPrice.Total);
      }
         
       }
        let obStartDur;
         let obEndDur;
          let ibStartDur;
           let ibEndDur;
           let ObDurLs=[];
           let IbDurLs=[];
       if(isOb && DurationSortedArray && DurationSortedArray.length!=0){
         for (let i = 0; i < DurationSortedArray.length; i++) {
           ObDurLs.push(DurationSortedArray[i][0].obFlight[0].flight.TotalDuration);
         }
       obStartDur= ObDurLs[0];
       obEndDur = ObDurLs[ObDurLs.length-1];
       }
       else if(!isOb && DurationSortedArray && DurationSortedArray.length!=0){
         for (let i = 0; i < DurationSortedArray.length; i++) {
           IbDurLs.push(DurationSortedArray[i][0].ibFlight[0].flight.TotalDuration);
         }
       ibStartDur = IbDurLs[0];
       ibEndDur = IbDurLs[IbDurLs.length-1];
       }
      
       
          pFilterWatch.price.priceLs=pOrgFilterLs.price.priceLs;
        depTime= [...new Set(depTime.map(item => item))];
          
          let isAlSel=false;
          let isDepTime=false;
          
         
      
            for(var j in pOrgFilterLs){
              if(pOrgFilterLs[j].length) {
              for(let k=0; k <pOrgFilterLs[j].length; k++) {
                if(j=='al') {

                  ///to check whether the AL filter is applied by user / not
                  let alFil = pOrgFilterLs.al.filter(alObj => alObj.by=='user')
              if(alFil.length!=0){
                isAlSel=true;
              }
                  if(pOrgFilterLs[j][k].by=='user'){
                    if(pOrgFilterLs[j][k].status==0){
                      pOrgFilterLs[j][k].by='default'
                    }
                    pOrgFilterLs[j][k].status=pOrgFilterLs[j][k].status;
                  }else{
                if(airlineCode.length!=0) {
                for(let l=0;l<airlineCode.length;l++){
                if(pOrgFilterLs[j][k].code == airlineCode[l]) {
                  pOrgFilterLs[j][k].status=0;
                  break;
                }
                else{
                  if(isAlSel!=true){
                  pOrgFilterLs[j][k].status=1;
                  }else{
                    pOrgFilterLs[j][k].status=0;
                  }
                }
                }
                }
                else{
                  pOrgFilterLs[j][k].status=1;
                }
                  }
                 } else if(j=='depTime') {
                    let depTimeFil = pOrgFilterLs.depTime.filter(depTimeObj => depTimeObj.by=='user')
              if(depTimeFil.length!=0){
                isDepTime=true;
              }
                  if(pOrgFilterLs[j][k].by=='user'){
                    if(pOrgFilterLs[j][k].status==0){
                      pOrgFilterLs[j][k].by='default'
                    }
                    pOrgFilterLs[j][k].status=pOrgFilterLs[j][k].status;
                  }else{
                if(depTime.length!=0) {
                for(let l=0;l<depTime.length;l++){
                if(pOrgFilterLs[j][k].start == depTime[l].start) {
                  pOrgFilterLs[j][k].status=0;
                  break;
                }
                else{
                  if(isDepTime!=true){
                  pOrgFilterLs[j][k].status=1;
                  }else{
                    pOrgFilterLs[j][k].status=0;
                  }
                }
                }
                }
                else{
                  pOrgFilterLs[j][k].status=1;
                }
                  }
                 }
                 else if(j=='stops') {
                    if(pOrgFilterLs[j][0].status!=1){
                for(let l=0;l<Stops.length;l++){
                 if(pOrgFilterLs[j][k].by=='user'){
                   pOrgFilterLs[j][k].status=pOrgFilterLs[j][k].status;
                 }else{
                if(pOrgFilterLs[j][k].code == Stops[l].code) {
                  pOrgFilterLs[j][k].status=1;
                  break;
                }
                else{
                  pOrgFilterLs[j][k].status=0;
                }
                }
                }
                    }
                  else{
                    pOrgFilterLs[j]=pOrgFilterLs[j];
                  } 
                 }
                 else if(j=='via') {
                    if(pOrgFilterLs[j][0].status!=1){
                for(let l=0;l<Via.length;l++){
                 if(pOrgFilterLs[j][k].by=='user'){
                   pOrgFilterLs[j][k].status=pOrgFilterLs[j][k].status;
                 }else{
                if(pOrgFilterLs[j][k].code == Via[l].code) {
                  pOrgFilterLs[j][k].status=1;
                  break;
                }
                else{
                  pOrgFilterLs[j][k].status=0;
                }
                }
                }
                    }
                  else{
                    pOrgFilterLs[j]=pOrgFilterLs[j];
                  } 
                 }
                
                 }
              }
              else{
               if(j=='price') {
                 if(pOrgFilterLs[j].by=='user'){
                    pOrgFilterLs[j].min=this.$options.filters.formatPrice(pFilterWatch.price.priceLs[0],'min');
                pOrgFilterLs[j].max=this.$options.filters.formatPrice(pFilterWatch.price.priceLs[ pFilterWatch.price.priceLs.length-1],'max');
               pOrgFilterLs[j].from=this.$options.filters.formatPrice(pOrgFilterLs[j].from,'min');
                pOrgFilterLs[j].to=this.$options.filters.formatPrice(pOrgFilterLs[j].to,'max');
                 pOrgFilterLs[j].by= pOrgFilterLs[j].by;
        
                 }else{
                  //  let softLimitVal = this.$options.filters.formatPrice(pOrgFilterLs[j].max*FILTER.SOFTLIMIT_VAL/100,'max');
                    
                if(priceLs[0] == priceLs[priceLs.length-1]) {
                   pOrgFilterLs[j].min=1
                  pOrgFilterLs[j].max=this.$options.filters.formatPrice(pOrgFilterLs[j].max,'max')+1;
                    pOrgFilterLs[j].from=2;
                    pOrgFilterLs[j].to=this.$options.filters.formatPrice(priceLs[priceLs.length-1],'max');
                   
                  }
                  else{
                    pOrgFilterLs[j].min=this.$options.filters.formatPrice(pOrgFilterLs[j].min,'min')
                pOrgFilterLs[j].max=this.$options.filters.formatPrice(pOrgFilterLs[j].max,'max')
                     pOrgFilterLs[j].from=this.$options.filters.formatPrice(priceLs[0],'min');
                     pOrgFilterLs[j].to=this.$options.filters.formatPrice(priceLs[priceLs.length-1],'max');
                  }
             
                 pOrgFilterLs[j].by= pOrgFilterLs[j].by;
        
                 }
                
                }else if(j=='totalDuration') {
                 if(pOrgFilterLs[j].by=='user'){
                    pOrgFilterLs[j].start=pOrgFilterLs[j].start;
                pOrgFilterLs[j].end=pOrgFilterLs[j].end;
               pOrgFilterLs[j].from=pOrgFilterLs[j].from;
                pOrgFilterLs[j].to=pOrgFilterLs[j].to;
                 pOrgFilterLs[j].by= pOrgFilterLs[j].by;
        
                 }else{
                    
                
                if(isOb && DurationSortedArray && DurationSortedArray.length!=0) {
                  
                  if(obStartDur == obEndDur) {
                   pOrgFilterLs[j].start=1;
                pOrgFilterLs[j].end=pOrgFilterLs[j].end;
                    pOrgFilterLs[j].from=2;
                    pOrgFilterLs[j].to= obEndDur;
                   
                  }
                  else{
                   pOrgFilterLs[j].start=pOrgFilterLs[j].start;
                pOrgFilterLs[j].end=pOrgFilterLs[j].end;
                  pOrgFilterLs[j].from=obStartDur;
                    pOrgFilterLs[j].to= obEndDur;
                   
                  }
              
                }else if(!isOb && DurationSortedArray && DurationSortedArray.length!=0){
                 
                  if(ibStartDur == ibEndDur) {
                  pOrgFilterLs[j].start=1;
                pOrgFilterLs[j].end=pOrgFilterLs[j].end;
                      pOrgFilterLs[j].from=2;
                    pOrgFilterLs[j].to=ibEndDur;
                  
                    
                  }else{
                    pOrgFilterLs[j].start=pOrgFilterLs[j].start;
                pOrgFilterLs[j].end=pOrgFilterLs[j].end;
                   pOrgFilterLs[j].from=ibStartDur;
                    pOrgFilterLs[j].to= ibEndDur;
                  }
                
                }
                 pOrgFilterLs[j].by= pOrgFilterLs[j].by;
        
                 }
                
                }
              }
            
              if(j=='al') {
              
               pFilterWatch.al=pOrgFilterLs[j];
              }
              else if(j=='stops') {
              
               pFilterWatch.stops=pOrgFilterLs[j];
              }
               else if(j=='price') {
                  pFilterWatch.price=pOrgFilterLs[j];
        
                 }
                 else if(j=='via') {
                  pFilterWatch.via=pOrgFilterLs[j];
        
                 }else if(j=='totalDuration') {
                  pFilterWatch.totalDuration=pOrgFilterLs[j];
        
                 }else if(j=='depTime') {
                  pFilterWatch.depTime=pOrgFilterLs[j];
        
                 }
             
            }
          
          
  

   
    
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TOUR_FLIGHT_RESULTS,
                  "error in getFilterData",
                  err.toString(),
                  "getFilterData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return pFilterWatch;
}, 
  

},
mounted() {
    this.$root.$emit("toggle-fixed-header", true);
    this.$root.$emit("toggle-sidebar-minimize");
},
    async created() {
     try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.$root.$emit("toggle-fixed-header", true);
      this.$root.$emit("toggle-sidebar-minimize");
              // this.SET_IS_MODIFY_SEARCH(false);

      await this.formattingFlightRes();
      
     
    } catch (err) {
      let body = Logger.buildRequest(
        PATHNAME.TOUR_FLIGHT_RESULTS,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  beforeCreate() {    
   addClassToBody(COMPONENT_NAME.TOUR_FLIGHT_RESULTS);
  },
  
   beforeDestroy() {
   
         this.$root.$emit("toggle-sidebar-minimize", true);
     
       removeClassBody();
    },

 

  computed: {

          DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
    ...mapGetters("sCSearch", {
      searchStoreObj: "GET_SEARCH_OBJ"
    }),
    ...mapGetters("sCSearch", {
      sRoutesObj: "GET_ROUTES_OBJ"
    }),
    ...mapGetters("sResult", {
      GET_ORG_BINDED_FLIGHT_LS:"GET_ORG_BINDED_FLIGHT_LS",
      GET_CHEAPEST_LS:"GET_CHEAPEST_LS",
      sSelObFlightObj: "GET_OB_FLIGHT_OBJ",
      sSelIbFlightObj: "GET_IB_FLIGHT_OBJ",
      GET_OB_SEL_SORT_VALUE:"GET_OB_SEL_SORT_VALUE",
      GET_IB_SEL_SORT_VALUE:"GET_IB_SEL_SORT_VALUE",
      GET_SEARCH_RES:'GET_SEARCH_RES',
      sStoreBindedLs: 'GET_BINDED_FLIGHT_LS',
      GET_AIRLINES: 'GET_AIRLINES',
      GET_OB_FILTER_DATA:'GET_OB_FILTER_DATA',
      GET_IB_FILTER_DATA:'GET_IB_FILTER_DATA',
      GET_OB_DISP_FILTER_LS:'GET_OB_DISP_FILTER_LS',
      GET_IB_DISP_FILTER_LS:'GET_IB_DISP_FILTER_LS',
      
    }),

  
  
   bindedFlightLs: {
   
    get: function () {
    let filteredLs={
        ob:null,
        ib:null
      };
     let selObSortOption = this.selObSortVal;
     let selIbSortOption = this.selIbSortVal;
   
    var filterObItems= cloneData(this.filterObWatchList);
    var filterIbItems= cloneData(this.filterIbWatchList);
  if(this.GET_ORG_BINDED_FLIGHT_LS!=null) {
    
     
      let bindFilterLs = this.GET_ORG_BINDED_FLIGHT_LS;
      let isobAlSel=false;
      let isobDepTime=false;
      let FilteredLs=[];
      if(filterObItems!=null)  {
        let alFil = filterObItems.al.filter(alObj => alObj.by=='user')
              if(alFil.length!=0){
                isobAlSel=true;
              }
       let depTimeFil = filterObItems.depTime.filter(depTimeObj => depTimeObj.by=='user')
              if(depTimeFil.length!=0){
                isobDepTime=true;
              }
      for(var x in filterObItems) {
        if(x== FILTER.C_FILTER_AL && isobAlSel) {
          filteredLs.ob = this.filterAL(bindFilterLs.ob,filterObItems[x],true);
         
        }
         if( this.isStopsForNonMyanmar && x== FILTER.C_FILTER_STOPS && filteredLs.ob!=null) {
           if(filterObItems[x][0] && filterObItems[x][0].status!=1) {
          filteredLs.ob = this.stopFilter(filteredLs.ob,filterObItems[x],true);
           }
       
        }
          else if( this.isStopsForNonMyanmar && x== FILTER.C_FILTER_STOPS) {
           if(filterObItems[x][0] && filterObItems[x][0].status!=1) {
          filteredLs.ob = this.stopFilter(bindFilterLs.ob,filterObItems[x],true);
           }
        
        }
        
        if( !this.isStopsForNonMyanmar && x== FILTER.C_FILTER_VIA && filteredLs.ob!=null) {
           if(filterObItems[x][0] && filterObItems[x][0].status!=1) {
          filteredLs.ob = this.viaFilter(filteredLs.ob,filterObItems[x],true);
           }
       
        }
          else if( !this.isStopsForNonMyanmar && x== FILTER.C_FILTER_VIA) {
           if(filterObItems[x][0] && filterObItems[x][0].status!=1) {
          filteredLs.ob = this.viaFilter(bindFilterLs.ob,filterObItems[x],true);
           }
        
        }
        if(x== FILTER.C_FILTER_PRICE && filteredLs.ob!=null) {
         
         
          for (var i in filteredLs.ob) {
            let priceFilterLs=this.filterPrice(filteredLs.ob[i],filterObItems[x]);
            if(priceFilterLs.length!=0){
              FilteredLs.push(priceFilterLs);
            }
          }
          filteredLs.ob=FilteredLs;
         
        }else if(x== FILTER.C_FILTER_PRICE) {
          
         
          for (var i in bindFilterLs.ob) {
          let priceFilterLs=this.filterPrice(bindFilterLs.ob[i],filterObItems[x]);
            if(priceFilterLs.length!=0){
              FilteredLs.push(priceFilterLs);
            }
      
          }
          filteredLs.ob=FilteredLs;
        }
        if(x== FILTER.C_FILTER_DUR && filteredLs.ob!=null) {
         filteredLs.ob = this.filterDuration(filteredLs.ob,filterObItems[x],true);
         
        } else if(x== FILTER.C_FILTER_DUR) {
         filteredLs.ob = this.filterDuration(bindFilterLs.ob,filterObItems[x],true);
         
        } 
        if(x== FILTER.C_FILTER_DEPTIME && isobDepTime && filteredLs.ob!=null) {
          filteredLs.ob = this.filterDepTime(filteredLs.ob,filterObItems[x],true);
         
        } else if(x== FILTER.C_FILTER_DEPTIME && isobDepTime) {
          filteredLs.ob = this.filterDepTime(bindFilterLs.ob,filterObItems[x],true);
        }
      }
        if((filteredLs.ob.length!=0) && this.GET_AIRLINES) {
          this.flightAlert=null;
          this.SET_OB_FILTER_DATA(filterObItems);
     filterObItems=this.assignFilterObj(filteredLs.ob,this.GET_AIRLINES,true);
     let isSelFlight;
     if(this.selFlight.ob!=null) {
     filteredLs.ob=this.toRemoveSelectableClass(filteredLs.ob,this.selFlight.ob);
     if(this.GET_OB_DISP_FILTER_LS && this.GET_OB_DISP_FILTER_LS.length!=0) {
     isSelFlight=this.tocheckForSelectedClass(filteredLs.ob,this.selFlight.ob,true);
     if(isSelFlight==false) {
      bindFilterLs.ob=this.tocheckForSelectedClass(bindFilterLs.ob,this.selFlight.ob,false);
       this.selFlight.ob=null;
     }
     }
     }
     }
     else{
       if(this.selFlight.ob!=null) {
        bindFilterLs.ob=this.tocheckForSelectedClass(bindFilterLs.ob,this.selFlight.ob,false);
       this.selFlight.ob=null;
       }
              this.flightAlert='No flights available on this range'
            }
      }
      let isibAlSel=false;
      let isibDepTime=false;
      let ibFilteredLs=[];
      if(filterIbItems!=null){
    let alFil = filterIbItems.al.filter(alObj => alObj.by=='user')
              if(alFil.length!=0){
                isibAlSel=true;
              }
    let depTimeFil = filterIbItems.depTime.filter(depTimeObj => depTimeObj.by=='user')
              if(depTimeFil.length!=0){
                isibDepTime=true;
              }
      for(var x in filterIbItems) {
         
        if(x== FILTER.C_FILTER_AL && isibAlSel) {
          filteredLs.ib = this.filterAL(bindFilterLs.ib,filterIbItems[x],false);
         
        }
        if( this.isStopsForNonMyanmar && x== FILTER.C_FILTER_STOPS && filteredLs.ib!=null) {
           if(filterIbItems[x][0] && filterIbItems[x][0].status!=1) {
          filteredLs.ib = this.stopFilter(filteredLs.ib,filterIbItems[x],false);
           }
       
        }
          else if( this.isStopsForNonMyanmar && x== FILTER.C_FILTER_STOPS) {
           if(filterIbItems[x][0] && filterIbItems[x][0].status!=1) {
          filteredLs.ib = this.stopFilter(bindFilterLs.ib,filterIbItems[x],false);
           }
        
        }
        if(x== FILTER.C_FILTER_VIA && filteredLs.ib!=null) {
          if(filterIbItems[x][0].status!=1) {
          filteredLs.ib = this.viaFilter(filteredLs.ib,filterIbItems[x],false);
          }
         
        } else if(x== FILTER.C_FILTER_VIA) {
           if(filterIbItems[x][0] && filterIbItems[x][0].status!=1) {
          filteredLs.ib = this.viaFilter(bindFilterLs.ib,filterIbItems[x],false);
           }
        
        }
       if(x== FILTER.C_FILTER_PRICE && filteredLs.ib!=null) {
         
         
          for (var i in filteredLs.ib) {
            let priceFilterLs=this.filterPrice(filteredLs.ib[i],filterIbItems[x]);
            if(priceFilterLs.length!=0) {
              ibFilteredLs.push(priceFilterLs);
            }
          
      
          }
          filteredLs.ib=ibFilteredLs;
         
        }else if(x== FILTER.C_FILTER_PRICE) {
          
         
          for (var i in bindFilterLs.ib) {
         let priceFilterLs=this.filterPrice(bindFilterLs.ib[i],filterIbItems[x]);
            if(priceFilterLs.length!=0) {
              ibFilteredLs.push(priceFilterLs);
            }
          
      
          }
          filteredLs.ib=ibFilteredLs;
        }
        if(x== FILTER.C_FILTER_DUR) {
         filteredLs.ib = this.filterDuration(filteredLs.ib,filterIbItems[x],false);
         
        }
        if(x== FILTER.C_FILTER_DEPTIME && isibDepTime && filteredLs.ib!=null) {
          filteredLs.ib = this.filterDepTime(filteredLs.ib,filterIbItems[x],false);
         
        } else if(x== FILTER.C_FILTER_DEPTIME && isibDepTime) {
          filteredLs.ib = this.filterDepTime(bindFilterLs.ib,filterIbItems[x],false);
        }
      }
      
       if(filteredLs.ib.length!=0 && this.GET_AIRLINES!=null) {
         this.flightAlert=null;
          this.SET_IB_FILTER_DATA(filterIbItems);
     filterIbItems=this.assignFilterObj(filteredLs.ib,this.GET_AIRLINES,false);
    let isSelFlight;
     if(this.selFlight.ib!=null) {
     filteredLs.ib=this.toRemoveSelectableClass(filteredLs.ib,this.selFlight.ib);
     if(this.GET_IB_DISP_FILTER_LS && this.GET_IB_DISP_FILTER_LS.length!=0) {
      isSelFlight=this.tocheckForSelectedClass(filteredLs.ib,this.selFlight.ib,true);
     if(!isSelFlight) {
    bindFilterLs.ib=this.tocheckForSelectedClass(bindFilterLs.ib,this.selFlight.ib,false);
       this.selFlight.ib=null;
     }
     }
     }
     }
     else{
       if(this.selFlight.ib!=null){
        bindFilterLs.ib=this.tocheckForSelectedClass(bindFilterLs.ib,this.selFlight.ib,false);
       this.selFlight.ib=null;
       }
              this.flightAlert='No flights available on this range'
            }
      }
     
      
 }
  
    
     if(selObSortOption!=null&& filteredLs.ob!=null) {
        if (selObSortOption.code == SORT.LOWEST_PRICE) {
          filteredLs.ob = this.sortByPrice(ORDER.ASC,filteredLs.ob,true);
        } else if (selObSortOption.code == SORT.HIGHEST_PRICE) {
          filteredLs.ob = this.sortByPrice(ORDER.DESC,filteredLs.ob,true);
        } else if (selObSortOption.code == SORT.EARLIEST_DEP) {
          filteredLs.ob = this.sortByDepDate(ORDER.ASC,filteredLs.ob,true);
        } else if (selObSortOption.code == SORT.EARLIEST_ARR) {
          filteredLs.ob = this.sortByArrDate(ORDER.ASC,filteredLs.ob,true);
        } else if (selObSortOption.code == SORT.SHORTEST_DUR) {
          filteredLs.ob = this.sortByDuration(ORDER.ASC,filteredLs.ob,true);
        }
     }
     if(selIbSortOption!=null && filteredLs.ib!=null) {
        if (selIbSortOption.code == SORT.LOWEST_PRICE) {
          filteredLs.ib = this.sortByPrice(ORDER.ASC,filteredLs.ib,false);
        } else if (selIbSortOption.code == SORT.HIGHEST_PRICE) {
          filteredLs.ib = this.sortByPrice(ORDER.DESC,filteredLs.ib,false);
        } else if (selIbSortOption.code == SORT.EARLIEST_DEP) {
          filteredLs.ib = this.sortByDepDate(ORDER.ASC,filteredLs.ib,false);
        } else if (selIbSortOption.code == SORT.EARLIEST_ARR) {
          filteredLs.ib = this.sortByArrDate(ORDER.ASC,filteredLs.ib,false);
        } else if (selIbSortOption.code == SORT.SHORTEST_DUR) {
          filteredLs.ib = this.sortByDuration(ORDER.ASC,filteredLs.ib,false);
        }
     }
      return filteredLs;

    },
  
    set: function () { 
    }
    
  },
 
    
  },
  
};
</script>
<style scoped>

    .flip-list-enter-active,
    .flip-list-leave-active{
        transition: all 1s;
    }
    .flip-list-enter, .flip-list-leave-to /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(30px);
    }


    .selectable {
        background-color: red;
    }

    .selected {
        background-color: green;
    }

    .disable {
        background-color: #d3d3d359;

        /*background-color: lightgray;*/
    }

    .disable-flight {
        background-color: grey;
    }
/* 
    .selected-flight {
      background-color:linen;
     }  */

    .no-class {
        background-color: white;
    }

    .list-item {
        display: inline-block;
        margin-right: 10px;
    }

    .list-enter-active,
    .list-leave-active{
        transition: all 1s;
    }

    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(30px);
    }

    .bounce-enter-active {
        animation: bounce-in 0.6s;
    }

    .bounce-leave-active {
        animation: bounce-in 0.3s reverse;
    }

    @keyframes bounce-in {
        0%{
            transform: translate(0%, -130%);

        }

        100%{
            transform: translate(0px, 0%);

        }
        /*0% {*/
        /*    transform: scale(0);*/
        /*}*/
        /*50% {*/
        /*    transform: scale(1.1);*/
        /*}*/
        /*100% {*/
        /*    transform: scale(1);*/
        /*}*/
    }

</style>
